/* ============================================================
   COLECCIONISTA EXPERTO — cliente
   Se carga solo en la página del juego, desde `myntic-juego.liquid`.

   La diferencia con el prototipo cabe en una frase: AQUÍ NO SE DECIDE
   NADA. Este archivo pinta, suena y anima; quién acierta, cuántos
   puntos son, cuánto tiempo queda y cuántos intentos restan lo dice el
   servidor. Si alguien edita este archivo en su navegador, lo único
   que consigue es romperse su propia pantalla.

   El reloj que se ve es decorativo: marca el tiempo para que el
   jugador decida, pero quien declara «fuera de tiempo» es el servidor,
   con su propio reloj y un margen para la latencia de la red.
   ============================================================ */
(function () {
  'use strict';

  const raiz = document.getElementById('ce');
  if (!raiz) return;
  const API = raiz.dataset.api || '/apps/coleccionista';

  const $ = id => document.getElementById(id);
  const pantallas = ['ce-load', 'ce-login', 'ce-nombre', 'ce-home', 'ce-play', 'ce-over', 'ce-board', 'ce-perfil', 'ce-premios'];
  /* CAMBIAR DE PANTALLA VUELVE ARRIBA.

     Sin esto, `.ce` —que es quien tiene el scroll cuando el juego ocupa
     la pantalla— conserva el desplazamiento de la pantalla anterior: se
     termina una partida con el dedo a media página y el resultado
     aparece ya cortado por arriba, con el título fuera de vista. Y como
     la pantalla nueva es más corta, a veces no queda recorrido para
     subir y se queda trabado. Es lo que reportó Leonardo con la captura
     del resultado. */
  /* UN NODO QUE NO ESTÁ NO PUEDE TUMBAR LA PARTIDA.

     `$(id).textContent = x` con el nodo ausente lanza un TypeError, y
     eso aborta la función entera: la pregunta se queda a medias, con el
     cuadro de otro reto en pantalla y sin explicación. Ya pasó una vez
     con un `let` usado antes de declararse y vuelve a pasar cada vez que
     el marcado y el script viajan por separado —el JS va en `assets/` y
     el HTML en la sección, y Shopify los sirve con cachés distintas, así
     que durante unos minutos puede haber un script nuevo sobre un
     marcado viejo—.
     Para los nodos que no existen en todas las pantallas se usa esto. */
  const texto = (id, t) => { const e = $(id); if (e) e.textContent = t; };
  const tapar = (id, v) => { const e = $(id); if (e) e.hidden = !!v; };
  const clase = (id, c, v) => { const e = $(id); if (e) e.classList.toggle(c, !!v); };

  const ver = id => {
    pantallas.forEach(p => { const e = $(p); if (e) e.hidden = (p !== id); });
    const caja = $('ce');
    if (caja) caja.scrollTop = 0;
    try { window.scrollTo(0, 0); } catch (e) {}
  };
  const dinero = v => '$' + Number(v).toLocaleString('es-MX');
  const num = v => Number(v).toLocaleString('es-MX');

  /* TODA PETICIÓN LLEVA PLAZO Y REINTENTO.

     Sin plazo, una petición que se queda colgada deja la partida muerta
     sin decir nada: el jugador pulsa una respuesta, no ocurre nada, y
     cuando por fin contesta el servidor ya se le pasó el tiempo. Fue lo
     que reportó Leonardo el 26 sep 2026.

     Se reintenta solo lo que es seguro repetir: los GET siempre, y
     `/responder` porque el servidor lo hace idempotente por número de
     pregunta. Un 4xx no se reintenta —si el cuerpo está mal o la partida
     no existe, insistir no lo arregla— salvo el 429, que pide esperar. */
  async function api(ruta, metodo, cuerpo, opc) {
    const o = opc || {};
    const plazo = o.plazo || 9000;
    const veces = o.reintentos == null ? ((metodo || 'GET') === 'GET' ? 2 : 0) : o.reintentos;
    let ultimo;
    for (let i = 0; i <= veces; i++) {
      try {
        const ctrl = new AbortController();
        const reloj = setTimeout(() => ctrl.abort(), plazo);
        let r;
        try {
          r = await fetch(API + ruta, {
            method: metodo || 'GET',
            headers: cuerpo ? { 'content-type': 'application/json' } : undefined,
            body: cuerpo ? JSON.stringify(cuerpo) : undefined,
            credentials: 'same-origin',
            signal: ctrl.signal
          });
        } finally { clearTimeout(reloj); }
        const data = await r.json().catch(() => ({ error: 'respuesta' }));
        if (!r.ok) {
          const e = new Error(data.error || 'error'); e.datos = data; e.status = r.status;
          if (r.status < 500 && r.status !== 429) throw e;
          ultimo = e;
        } else return data;
      } catch (e) {
        if (e.status && e.status < 500 && e.status !== 429) throw e;
        ultimo = e;
      }
      if (i < veces) await new Promise(r => setTimeout(r, 400 * (i + 1)));
    }
    throw ultimo || new Error('error');
  }

  /* ---------- Estado de pantalla, no del juego ---------- */
  const S = { datos: null, vidaEn: null, tVida: 0, partida: null, pregunta: null, raf: 0, bloqueado: true, enVuelo: false, salvavidas: 0, finLocal: 0, ultimoTick: -1 };

  /* ============================================================
     SONIDO — idéntico al prototipo: sintetizado, sin archivos.
     ============================================================ */
  const ESCALA = [523.25, 587.33, 659.25, 783.99, 880, 1046.5, 1174.66, 1318.51, 1567.98, 1760];
  /* EL SONIDO VIENE ENCENDIDO.

     Estaba apagado y había que activarlo con un botón: de toda la gente
     que probó el juego, ninguna lo encontró, y alguna perdió la partida
     buscándolo mientras corría el reloj. Un juego con sonido apagado por
     defecto es un juego sin sonido.
     Se recuerda la decisión del jugador: si lo silencia, sigue
     silenciado la próxima vez. */
  const PREF = 'myntic-ce-audio';
  /* UN PERDÓN, UNA SOLA VEZ.

     Hasta el 27 sep 2026, el primer toque en los botones de audio
     silenciaba en vez de encender —ver el comentario de `ce-mus`— y
     guardaba ese silencio para siempre. Quien cayó en la trampa se quedó
     sin sonido sin haberlo pedido, y no tenía forma de saber por qué.

     Las preferencias guardadas antes del arreglo no llevan versión: se
     descartan una vez y el juego vuelve a su estado de fábrica. Quien
     silencie a partir de ahora se queda silenciado, porque lo guardado
     ya lleva `v`.

     No se puede distinguir a quien silenció a propósito de quien cayó en
     el fallo, pero el error cae del lado correcto: el botón no permitía
     encender, así que un silencio viejo es más probable que sea el fallo
     que una decisión. */
  const PREF_V = 2;
  function leerPref() {
    try {
      const v = JSON.parse(localStorage.getItem(PREF));
      if (!v || typeof v !== 'object') return {};
      if (v.v !== PREF_V) return {};
      return v;
    } catch (e) { return {}; }
  }
  function guardarPref(o) {
    o.v = PREF_V;
    try { localStorage.setItem(PREF, JSON.stringify(o)); } catch (e) {}
  }
  const pref = leerPref();

  const A = {
    on: pref.efectos !== false, ctx: null,
    boot() { if (!this.ctx) { try { this.ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { } } },
    seq(ns) {
      if (!this.on || !this.ctx) return;
      if (this.ctx.state !== 'running') this.ctx.resume();
      const t0 = this.ctx.currentTime;
      ns.forEach(n => {
        const o = this.ctx.createOscillator(), g = this.ctx.createGain();
        o.type = n.tipo || 'sine';
        o.frequency.setValueAtTime(n.f, t0 + n.t);
        if (n.f2) o.frequency.exponentialRampToValueAtTime(n.f2, t0 + n.t + n.d);
        /* Los efectos suben también, pero menos que la música: ya se
           oían: lo que faltaba era cuerpo, no volumen bruto. */
        const v = (n.vol == null ? .12 : n.vol) * 1.5;
        g.gain.setValueAtTime(0, t0 + n.t);
        g.gain.linearRampToValueAtTime(v, t0 + n.t + .012);
        g.gain.exponentialRampToValueAtTime(.0001, t0 + n.t + n.d);
        o.connect(g).connect(this.ctx.destination);
        o.start(t0 + n.t); o.stop(t0 + n.t + n.d + .03);
      });
    },
    good(r) { const f = ESCALA[Math.min(Math.max(r, 1) - 1, ESCALA.length - 1)]; this.seq([{ f, t: 0, d: .15 }, { f: f * 1.5, t: .055, d: .17, vol: .09 }]); },
    bad() { this.seq([{ f: 311, f2: 180, t: 0, d: .3, tipo: 'triangle', vol: .13 }, { f: 155, f2: 98, t: .09, d: .34, tipo: 'triangle', vol: .1 }]); },
    mult() { this.seq([{ f: 659, t: 0, d: .13 }, { f: 880, t: .07, d: .13 }, { f: 1319, t: .14, d: .22, vol: .11 }]); },
    hito() { this.seq([{ f: 523, t: 0, d: .11 }, { f: 659, t: .06, d: .11 }, { f: 784, t: .12, d: .11 }, { f: 1047, t: .18, d: .13 }, { f: 1319, t: .25, d: .3, vol: .12 }]); },
    grial() { this.seq([{ f: 1047, t: 0, d: .18, tipo: 'triangle', vol: .1 }, { f: 1568, t: .08, d: .2, tipo: 'triangle', vol: .09 }, { f: 2093, t: .16, d: .34, tipo: 'triangle', vol: .07 }]); },
    record() { this.seq([{ f: 784, t: 0, d: .12 }, { f: 988, t: .08, d: .12 }, { f: 1175, t: .16, d: .12 }, { f: 1568, t: .24, d: .36, vol: .13 }]); },
    /* El récord de la casa suena un escalón por encima del propio: misma
       fanfarria, más larga y con la octava de remate. */
    global() { this.seq([{ f: 523, t: 0, d: .11 }, { f: 659, t: .07, d: .11 }, { f: 784, t: .14, d: .11 },
                         { f: 1047, t: .21, d: .13 }, { f: 1319, t: .3, d: .13 }, { f: 1568, t: .39, d: .15 },
                         { f: 2093, t: .5, d: .5, vol: .12 }]); },
    tick(s) { const m = { 5: [880, .05], 4: [988, .055], 3: [1100, .065], 2: [1300, .08], 1: [1600, .1] }[s] || [1100, .06]; this.seq([{ f: m[0], t: 0, d: .06, vol: m[1] }]); },
    end() { this.seq([{ f: 523, t: 0, d: .2, tipo: 'triangle' }, { f: 392, t: .13, d: .22, tipo: 'triangle' }, { f: 262, t: .26, d: .42, tipo: 'triangle', vol: .11 }]); },
    canje() { this.seq([{ f: 523, t: 0, d: .16 }, { f: 659, t: .09, d: .16 }, { f: 784, t: .18, d: .16 }, { f: 1047, t: .27, d: .2 }, { f: 1319, t: .36, d: .22 }, { f: 1568, t: .45, d: .55, vol: .13 }]); },
    /* Al pulsar una opción, ANTES de saber si acertó: un toque seco que
       confirma que el golpe entró. Sin él hay un silencio de milésimas
       mientras viaja la respuesta al servidor, y ese silencio se siente
       como que el botón no funcionó. */
    toque() { this.seq([{ f: 440, t: 0, d: .045, tipo: 'square', vol: .045 }]); },
    /* El corte de un encuadre a otro en una pieza Grial. Seco y bajo:
       marca el cambio sin competir con el resto. */
    salto() { this.seq([{ f: 1320, t: 0, d: .04, tipo: 'square', vol: .035 }]); },
    /* Cuenta atrás de arranque de partida. */
    vamos() { this.seq([{ f: 392, t: 0, d: .12 }, { f: 523, t: .12, d: .12 }, { f: 784, t: .24, d: .3, vol: .13 }]); }
  };
  /* ============================================================
     MÚSICA — pista de juego, no música ambiental

     La versión anterior tenía bajo y arpegio, pero le faltaba lo que
     hace que una pista empuje: PERCUSIÓN y VARIACIÓN. Sin batería no
     hay a qué agarrarse; sin variación, cuatro compases idénticos en
     bucle se vuelven papel pintado a los dos minutos y el oído deja de
     oírlos.

     Lo que suena ahora, por capas:
     · bombo en 1 y 3, caja en 2 y 4 — el esqueleto;
     · charles en corcheas, que es lo que da la sensación de prisa;
     · bajo con nota de paso al final del compás, para que el ciclo
       tire hacia el siguiente en vez de cerrarse;
     · arpegio sobre el acorde;
     · cada cuatro compases, un compás con relleno.

     Y sigue creciendo con la racha: a partir de 5 aciertos el charles
     va a semicorcheas y entra una segunda voz una octava arriba. El
     jugador no lo analiza; nota que la cosa se está poniendo seria.

     Todo sintetizado —cero archivos, cero descarga— y con su propio
     nodo de ganancia para poder bajarla sin tocar los efectos, que son
     los que informan y nunca deben quedar tapados.
     ============================================================ */
  const M = {
    on: false, quiere: pref.musica !== false, timer: 0, gain: null, compas: 0, nivel: 0, pista: 'salon',

    /* ---- PISTA DE SALÓN: la portada, la tabla, las recompensas ----
       Am7 - Fmaj7 - Cmaj7 - G, con la fundamental y la nota de paso que
       lleva al acorde siguiente. Suena a sitio donde se mira, no a sitio
       donde se compite. */
    prog: [
      { raiz: 110.00, paso: 123.47, notas: [220.00, 261.63, 329.63, 392.00] },
      { raiz: 87.31,  paso: 98.00,  notas: [174.61, 220.00, 261.63, 329.63] },
      { raiz: 130.81, paso: 146.83, notas: [261.63, 329.63, 392.00, 493.88] },
      { raiz: 98.00,  paso: 110.00, notas: [196.00, 246.94, 293.66, 392.00] }
    ],

    /* ---- PISTA DE PARTIDA: 8 bits, en La menor armónica ----

       Cuarta versión (26 sep 2026). La anterior tenía el sonido bien
       —onda pulso, arpegio rápido, envolvente seca— pero cansaba: ocho
       compases en Do mayor repitiéndose idénticos, y en una partida de
       varios minutos eso se vuelve papel pintado. Leonardo pidió que
       fuese más digerible y que transmitiera tensión, misterio y reto.

       Tres cambios de composición, no de timbre:

       1. LA MENOR ARMÓNICA en vez de Do mayor. La séptima elevada —el
          sol sostenido— es lo que da ese color de intriga: crea un salto
          de segunda aumentada que el oído lee como algo sin resolver.
          Alegre era lo contrario de lo que hacía falta.

       2. TRES SECCIONES QUE ROTAN, no un bucle. Suenan A-B-A-C, así que
          la vuelta completa son cuatro secciones y no se reconoce hasta
          pasado casi un minuto. A es la que respira —pedal y silencios—,
          B aprieta subiendo, C es la de más movimiento.

       3. MENOS NOTAS. La melodía anterior no paraba; esta deja huecos
          largos, y el hueco es lo que hace que la nota siguiente pese.
          La percusión entra por secciones en vez de sonar siempre.

       Composición propia. La armonía es de uso común; la melodía es de
       la casa y no reproduce ninguna pieza existente.

       Formato: [frecuencia, duración en semicorcheas]. `null` = silencio.
       `acorde` es el tipo para el arpegio de las notas largas. */
    chip: {
      bpm: 132,
      orden: [0, 1, 0, 2],
      secciones: [
        /* ── A · misterio: pedal de la menor y mucho aire ── */
        {
          acorde: 'm',
          percusion: 'suelta',
          melodia: [
            [440.00,4],[null,4],[523.25,4],[null,4],
            [659.25,6],[587.33,2],[523.25,4],[null,4],
            [493.88,4],[null,4],[415.30,4],[null,4],
            [440.00,8],[null,8]
          ],
          bajo: [
            [110.00,4],[null,4],[110.00,4],[null,4],
            [110.00,4],[null,4],[164.81,4],[null,4],
            [110.00,4],[null,4],[110.00,4],[null,4],
            [110.00,8],[null,8]
          ]
        },
        /* ── B · tensión: sube y se queda en la dominante ── */
        {
          acorde: 'm',
          percusion: 'media',
          melodia: [
            [587.33,2],[659.25,2],[698.46,4],[659.25,4],[587.33,4],
            [880.00,4],[830.61,4],[659.25,8],
            [698.46,2],[659.25,2],[587.33,2],[523.25,2],[493.88,4],[415.30,4],
            [440.00,8],[null,8]
          ],
          bajo: [
            [146.83,4],[146.83,4],[146.83,4],[110.00,4],
            [ 82.41,4],[ 82.41,4],[164.81,4],[ 82.41,4],
            [ 87.31,4],[ 87.31,4],[ 98.00,4],[ 98.00,4],
            [110.00,8],[ 82.41,8]
          ]
        },
        /* ── C · reto: la más movida, y cierra volviendo a la tónica ── */
        {
          acorde: 'm',
          percusion: 'llena',
          melodia: [
            [880.00,2],[1046.50,2],[987.77,2],[880.00,2],[830.61,4],[659.25,4],
            [698.46,2],[659.25,2],[587.33,2],[523.25,2],[493.88,4],[440.00,4],
            [523.25,2],[587.33,2],[659.25,2],[698.46,2],[830.61,6],[null,2],
            [880.00,10],[null,6]
          ],
          bajo: [
            [110.00,2],[110.00,2],[220.00,2],[110.00,2],[164.81,2],[110.00,2],[220.00,2],[110.00,2],
            [ 87.31,2],[ 87.31,2],[174.61,2],[ 87.31,2],[ 98.00,2],[ 98.00,2],[196.00,2],[ 98.00,2],
            [146.83,2],[146.83,2],[293.66,2],[146.83,2],[ 82.41,2],[ 82.41,2],[164.81,2],[ 82.41,2],
            [110.00,4],[220.00,4],[110.00,4],[164.81,4]
          ]
        }
      ]
    },

    /* ---- PISTA DE TASACIÓN: jazz noir, en Re menor ----

       El reto de expansiones no se juega con los dedos, se juega con el
       ojo: la carta se ve entera desde el primer segundo y hay que
       reconocer el marco, el estilo de la ilustración y la rareza. Eso
       no pide una pista que empuje a correr — pide una que deje pensar.
       El chiptune hacía lo contrario, y además tira del juego hacia el
       salón recreativo justo cuando el manual pide galería.

       Así que aquí manda otra imagen: la mesa del tasador. Contrabajo
       pulsado caminando, vibráfono, escobillas. Suena a sitio donde se
       examina una pieza con lupa, que es exactamente lo que se está
       haciendo.

       Decisiones de composición, y el porqué de cada una:

       1. SWING, no cuadrícula. Las corcheas de contratiempo caen al 62 %
          del tiempo en vez de al 50. Es lo que separa «música de juego»
          de «música tocada por alguien», y cuesta una función.

       2. MELODÍA CON HUECOS. Casi todo son silencios y una nota suelta
          de vibráfono. Una melodía con gancho compite con el pensamiento
          del jugador; el bajo caminante acompaña sin pedir turno.

       3. SEIS SECCIONES EN EL CICLO (A-B-A-C-A-D), 22 compases, unos 51
          segundos. La queja contra la pista anterior fue que cansaba de
          tan repetitiva: aquí la vuelta completa tarda casi el doble y
          la A vuelve cambiada de vecindario cada vez.

       4. MÁS BAJA QUE LAS OTRAS DOS. Es acompañamiento, no banda sonora.

       Armonía de uso común —el ii-V-i menor de toda la vida—; la melodía
       es de la casa y no reproduce ninguna pieza existente.

       Formato: cada compás lleva `bajo` (cuatro negras, `null` calla) y
       `voz` (uno o dos acordes de vibráfono; con dos, el segundo entra a
       mitad de compás). `melodia` va en corcheas: [frecuencia, duración].
       ---------------------------------------------------------------- */
    mesa: {
      bpm: 104,
      /* 0.62 y no 0.667: el swing de tresillo estricto suena a cliché de
         dibujos animados. Este es el de un trío tocando despacio. */
      swing: 0.62,
      orden: [0, 1, 0, 2, 0, 3],
      secciones: [
        /* ── A · la mesa: vamp de Dm9 y sitio para pensar ── */
        {
          ritmo: 'escobilla',
          compases: [
            { bajo: [ 73.42, 110.00,  87.31,  98.00], voz: [[174.61, 220.00, 261.63, 329.63]] },
            { bajo: [ 98.00, 146.83, 116.54, 130.81], voz: [[233.08, 293.66, 349.23, 440.00]] },
            { bajo: [ 73.42,  87.31, 110.00, 130.81], voz: [[174.61, 220.00, 261.63, 329.63]] },
            /* Em7b5 y A7b9: el ii-V que devuelve a la tónica. */
            { bajo: [ 82.41,  98.00, 110.00, 138.59],
              voz: [[196.00, 233.08, 293.66], [277.18, 392.00, 466.16]] }
          ],
          melodia: [
            [null,4],[440.00,2],[null,2],
            [null,2],[587.33,3],[null,3],
            [null,4],[349.23,2],[329.63,2],
            [293.66,3],[null,1],[261.63,2],[null,2]
          ]
        },
        /* ── B · se calienta: sube al Si bemol y vuelve por la dominante ── */
        {
          ritmo: 'ride',
          compases: [
            { bajo: [116.54,  87.31, 146.83, 130.81], voz: [[293.66, 349.23, 440.00, 523.25]] },
            { bajo: [110.00, 164.81, 138.59,  98.00], voz: [[277.18, 392.00, 466.16]] },
            { bajo: [ 73.42, 110.00,  87.31,  82.41], voz: [[174.61, 220.00, 261.63, 329.63]] },
            { bajo: [ 73.42, 130.81, 116.54, 110.00], voz: [[174.61, 220.00, 261.63, 329.63]] }
          ],
          melodia: [
            [349.23,2],[392.00,2],[440.00,3],[null,1],
            [466.16,2],[440.00,2],[392.00,2],[349.23,2],
            [329.63,3],[293.66,2],[null,3],
            [261.63,2],[293.66,2],[null,4]
          ]
        },
        /* ── C · la corrida: el bajo camina de verdad y el ride aprieta ── */
        {
          ritmo: 'llena',
          compases: [
            { bajo: [ 82.41,  98.00, 116.54, 146.83], voz: [[196.00, 233.08, 293.66]] },
            { bajo: [110.00, 138.59, 164.81, 196.00], voz: [[277.18, 392.00, 466.16]] },
            { bajo: [ 73.42,  87.31, 110.00, 130.81], voz: [[174.61, 220.00, 261.63, 329.63]] },
            { bajo: [ 73.42,  82.41,  87.31,  98.00], voz: [[174.61, 220.00, 261.63, 329.63]] }
          ],
          melodia: [
            [392.00,1],[466.16,1],[587.33,2],[null,4],
            [554.37,2],[466.16,1],[392.00,1],[329.63,4],
            [349.23,1],[440.00,1],[523.25,2],[440.00,2],[349.23,2],
            [293.66,4],[null,4]
          ]
        },
        /* ── D · la duda: dos compases casi vacíos antes de volver ── */
        {
          ritmo: 'nada',
          compases: [
            { bajo: [ 73.42, null, 110.00, null], voz: [[174.61, 220.00, 261.63, 329.63]] },
            { bajo: [ 73.42, null,   null, 138.59], voz: [[174.61, 220.00, 261.63, 329.63]] }
          ],
          melodia: [
            [null,8],
            [null,6],[440.00,2]
          ]
        }
      ]
    },

    /* ---- PISTA DE ENIGMA: adivinanza, en Re dorio ----

       Reescrita el 27 sep 2026. La anterior era un ostinato con reloj y
       campana, o sea TENSIÓN: te apura. Y este reto no se juega con
       prisa, se juega tasando — mirando dos cartas y pensando cuál vale
       más. Una pista que empuja ahí estorba, porque le pide al jugador lo
       contrario de lo que el juego le pide.

       Lo que hace que una pista suene a adivinanza son tres cosas:

       · LA FRASE PREGUNTA Y SE CALLA. Tres notas que suben y dos tiempos
         de silencio. Una melodía que sube es, literalmente, cómo suena
         una pregunta al hablar; y el hueco de después es donde se piensa.
         El silencio está escrito en la frase, no es lo que sobra.
       · NO RESUELVE NUNCA. La vuelta acaba en un Si sobre bajo de La: la
         novena, ni tercera ni séptima, que deja el acorde abierto. Cerrar
         en Re menor daría la sensación de haber acertado antes de tiempo.
       · MADERA, NO METAL. Marimba y bloque de madera. El metal suena a
         alarma; la madera suena a alguien dando golpecitos en la mesa
         mientras decide.

       El modo es DORIO y no menor natural: la sexta mayor —el Si sobre Re
       menor— quita el luto y deja la curiosidad. Es la diferencia entre
       un enigma y una desgracia.

       98 ppm: el pulso de alguien que examina, no de alguien que corre.
       Composición propia; no se copia ninguna pieza existente.

       Formato: `bajo` una nota por tiempo (null = callado), `frase` las
       notas de la melodía como [nota, corchea en que entra, largo en
       corcheas], `aire` un acorde tenido de fondo. Por sección: `bloques`
       las corcheas que marca la madera, `latir` los tiempos del pulso
       grave y `aprieta` si admite plato con racha alta. */
    enigma: {
      bpm: 98,
      /* A · B · A · C — la pregunta, el apretón, la pregunta otra vez y
         el hueco. Catorce compases, unos 34 segundos de vuelta. */
      orden: [0, 1, 0, 2],
      secciones: [
        /* ── A · la pregunta. Re menor · Sol · Re menor · La suspendido ── */
        { bloques: [2, 6], latir: [0], compases: [
            { bajo: [ 73.42, null, 110.00, null],
              frase: [[293.66, 0, 1], [349.23, 1, 1], [440.00, 2, 2]] },
            { bajo: [ 98.00, null, 146.83, null],
              frase: [[392.00, 0, 1], [440.00, 1, 1], [523.25, 2, 2]] },
            /* Aquí la pregunta insiste: el mismo giro y un salto a la
               octava en el tercer tiempo. */
            { bajo: [ 73.42, null,  87.31, null],
              frase: [[293.66, 0, 1], [349.23, 1, 1], [440.00, 2, 1], [587.33, 4, 3]] },
            /* Y se queda en el aire: Si sobre La, sin tercera. */
            { bajo: [110.00, null, 164.81, null],
              frase: [[440.00, 0, 2], [493.88, 2, 4]] } ] },
        /* ── B · aprieta. Las notas van en parejas: preguntar dos veces
              seguidas sin esperar respuesta. Fa · Sol · La menor · La sus ── */
        { bloques: [0, 2, 4, 6], latir: [0, 2], aprieta: true, compases: [
            { bajo: [ 87.31, 130.81,  87.31, 110.00],
              frase: [[349.23, 0, 1], [440.00, 1, 2], [523.25, 3, 1],
                      [440.00, 4, 2], [349.23, 6, 1], [523.25, 7, 1]] },
            { bajo: [ 98.00, 146.83,  98.00, 123.47],
              frase: [[392.00, 0, 1], [493.88, 1, 2], [587.33, 3, 1],
                      [493.88, 4, 2], [392.00, 6, 1], [587.33, 7, 1]] },
            { bajo: [110.00, 164.81, 110.00, 130.81],
              frase: [[440.00, 0, 1], [523.25, 1, 2], [659.25, 3, 1],
                      [523.25, 4, 2], [440.00, 6, 1], [659.25, 7, 1]] },
            { bajo: [110.00, 164.81, 123.47, 164.81],
              frase: [[440.00, 0, 1], [587.33, 1, 2], [493.88, 3, 1],
                      [587.33, 4, 2], [440.00, 6, 1], [493.88, 7, 1]] } ] },
        /* ── C · el hueco. Dos compases con una nota cada uno. Es lo que
              hace que la vuelta pese: sin este vacío, la frase de A es
              una más y no una pregunta. ── */
        { bloques: [], latir: [], compases: [
            { bajo: [ 73.42, null, null, null], frase: [[440.00, 0, 4]],
              aire: [146.83, 220.00] },
            { bajo: [ 73.42, null, 110.00, null], frase: [[293.66, 4, 4]],
              aire: [146.83, 220.00] } ] }
      ]
    },

    /* Las ondas se construyen una vez y se reutilizan: crear una
       PeriodicWave por nota sería tirar trabajo en cada semicorchea. */
    ondas: null,
    formas() {
      if (this.ondas || !A.ctx) return this.ondas;
      const hacer = (duty) => {
        const n = 24, re = new Float32Array(n), im = new Float32Array(n);
        for (let k = 1; k < n; k++) re[k] = (2 / (k * Math.PI)) * Math.sin(k * Math.PI * duty);
        return A.ctx.createPeriodicWave(re, im, { disableNormalization: false });
      };
      this.ondas = { fino: hacer(0.125), medio: hacer(0.25), ancho: hacer(0.5) };
      return this.ondas;
    },

    arrancar() {
      if (this.on || !A.ctx) return;
      this.on = true; this.quiere = true;
      this.cortar();            /* por si quedaba algo de una pista previa */
      this.abrirCanal();
      this.compas = 0;
      this.programar();
    },

    programar() {
      clearTimeout(this.timer);
      /* LA DURACIÓN SE MIDE ANTES DE TOCAR, y no es un detalle de orden:
         `tocar()` incrementa `compas` al terminar, así que calculada
         después salía la de la sección SIGUIENTE. Con todas las secciones
         del mismo largo —el caso del chiptune— no se nota; en la pista de
         tasación la última dura la mitad que las demás, y el resultado
         era un silencio de cuatro segundos y medio en cada vuelta del
         ciclo, más un solape antes. Es lo que Leonardo oyó como «la
         música se detiene cada cierto tiempo». */
      /* Salón: compás de 2,22 s a 108 ppm. */
      let ms = 2222;
      if (this.pista === 'chip') {
        const { orden, secciones } = this.chip;
        const sec = secciones[orden[this.compas % orden.length]];
        ms = (60000 / this.chip.bpm) / 4 * this.largoSeccion(sec);
      } else if (this.pista === 'mesa') {
        /* Aquí el bloque es una sección entera, y duran distinto: la D
           son dos compases y las demás cuatro. */
        const { orden, secciones, bpm } = this.mesa;
        const sec = secciones[orden[this.compas % orden.length]];
        ms = sec.compases.length * 4 * (60000 / bpm);
      } else if (this.pista === 'enigma') {
        const { orden, secciones, bpm } = this.enigma;
        const sec = secciones[orden[this.compas % orden.length]];
        ms = sec.compases.length * 4 * (60000 / bpm);
      }
      this.tocar();
      /* `setTimeout` en cadena y no `setInterval`: las secciones duran
         distinto, así que el siguiente aviso tiene que calcularse cada
         vez con la sección que venga. */
      this.timer = setTimeout(() => { if (this.on && this.gain) this.programar(); }, ms);
    },

    /* Cambiar de pista sin cortar: cada minijuego tiene la suya y la
       interfaz la de salón. */
    /* CAMBIAR DE PISTA CORTA LA ANTERIOR DE VERDAD.

       Reprogramar el temporizador no bastaba: Web Audio agenda cada nota
       con su hora de arranque, así que la vuelta que ya estaba puesta
       seguía sonando por debajo de la nueva. Al perder, la pista de
       partida terminaba su ciclo encima de la de la interfaz — que es lo
       que se oía en la pantalla de resultado.

       Se corta desconectando el nodo de volumen por el que pasa toda la
       pista: los osciladores agendados siguen ahí pero ya no llegan a
       ningún sitio, y se apagan solos al cumplir su hora. El corte lleva
       120 ms de desvanecido para que no chasquee. */
    cortar() {
      clearTimeout(this.timer); this.timer = 0;
      const viejo = this.gain;
      this.gain = null;
      if (!viejo || !A.ctx) return;
      const t = A.ctx.currentTime;
      try {
        viejo.gain.cancelScheduledValues(t);
        viejo.gain.setValueAtTime(viejo.gain.value, t);
        viejo.gain.linearRampToValueAtTime(0, t + 0.12);
      } catch (e) {}
      /* Desconectar antes de tiempo cortaría en seco; se espera al final
         del desvanecido y además así se libera el nodo. */
      setTimeout(() => { try { viejo.disconnect(); } catch (e) {} }, 400);
    },

    abrirCanal() {
      this.gain = A.ctx.createGain();
      this.gain.gain.value = 0.34;
      this.gain.connect(A.ctx.destination);
    },

    cambiar(p) {
      if (this.pista === p) return;
      this.pista = p;
      this.compas = 0;
      if (!this.on) return;
      this.cortar();
      this.abrirCanal();
      this.programar();
    },

    tono(f, t, dur, tipo, vol, f2) {
      const o = A.ctx.createOscillator(), g = A.ctx.createGain();
      o.type = tipo; o.frequency.setValueAtTime(f, t);
      if (f2) o.frequency.exponentialRampToValueAtTime(f2, t + dur);
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(vol, t + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      if (!this.gain) return;
      o.connect(g).connect(this.gain);
      o.start(t); o.stop(t + dur + 0.02);
    },

    /* UNA VOZ DE PULSO. Ataca y corta en seco, sin rampas: el hardware
       de aquellas consolas no sabía hacer otra cosa y por eso suena así.
       `forma` elige el ciclo de trabajo —fino, medio o ancho— y `vib`
       añade el temblor que llevaban las notas largas. */
    pulso(f, t, dur, vol, forma, vib) {
      if (!f || !A.ctx || !this.gain) return;
      const o = A.ctx.createOscillator(), g = A.ctx.createGain();
      const w = this.formas();
      if (w && w[forma || 'fino']) o.setPeriodicWave(w[forma || 'fino']);
      else o.type = 'square';
      o.frequency.setValueAtTime(f, t);
      if (vib && dur > 0.25) {
        /* Vibrato solo en las notas que duran: en una semicorchea no se
           oiría y solo ensuciaría el ataque. */
        const lfo = A.ctx.createOscillator(), prof = A.ctx.createGain();
        lfo.frequency.setValueAtTime(5.5, t);
        prof.gain.setValueAtTime(0, t);
        prof.gain.linearRampToValueAtTime(f * 0.011, t + 0.12);
        lfo.connect(prof).connect(o.frequency);
        lfo.start(t); lfo.stop(t + dur);
      }
      g.gain.setValueAtTime(vol, t);
      g.gain.setValueAtTime(vol, t + dur * 0.82);
      g.gain.linearRampToValueAtTime(0, t + dur * 0.95);
      o.connect(g).connect(this.gain);
      o.start(t); o.stop(t + dur + 0.01);
    },

    /* EL ARPEGIO ULTRARRÁPIDO, que es lo que de verdad suena a consola.
       Con dos canales de melodía no se podía tocar un acorde, así que se
       alternaban sus notas cada uno o dos fotogramas: el oído lo junta y
       oye un acorde con un trino metálico encima.
       Los intervalos van en razones de temperamento igual sobre la nota
       escrita, así sirve para cualquier altura sin tabla de acordes. */
    arpegio(f, t, dur, vol, tipo) {
      const tercera = tipo === 'm' ? 1.18921 : 1.25992;   /* 3 o 4 semitonos */
      const notas = [f, f * tercera, f * 1.49831];        /* + la quinta */
      const paso = 0.045;
      const n = Math.max(3, Math.round(dur / paso));
      for (let i = 0; i < n; i++) {
        this.pulso(notas[i % 3], t + i * paso, paso * 0.92, vol, 'fino', false);
      }
    },

    /* Bombo: un seno que cae rápido de 110 a 42 Hz. Es el truco de
       siempre y funciona porque el oído lo lee como un golpe. */
    bombo(t) { this.tono(110, t, 0.18, 'sine', this.pista === 'chip' ? 0.34 : 0.55, 42); },

    /* Caja y charles: ruido filtrado. Un oscilador no suena a
       percusión; hace falta ruido, y el filtro decide si es caja
       (grave, cuerpo) o charles (agudo, chasquido). */
    ruido(t, dur, frec, vol, q) {
      if (!this.gain) return;
      const n = A.ctx.sampleRate * dur;
      const buf = A.ctx.createBuffer(1, n, A.ctx.sampleRate);
      const d = buf.getChannelData(0);
      for (let i = 0; i < n; i++) d[i] = Math.random() * 2 - 1;
      const src = A.ctx.createBufferSource(); src.buffer = buf;
      const f = A.ctx.createBiquadFilter();
      f.type = 'bandpass'; f.frequency.value = frec; f.Q.value = q || 1;
      const g = A.ctx.createGain();
      g.gain.setValueAtTime(vol, t);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      src.connect(f).connect(g).connect(this.gain);
      src.start(t); src.stop(t + dur);
    },
    /* ---- TIMBRES DE LA MESA ----
       La percusión de arriba es de caja de ritmos: sirve al chiptune y
       al salón, y aquí sonaría a otra cosa. Estos cuatro son propios de
       la pista de tasación. */

    /* CONTRABAJO PULSADO. El truco no está en la onda sino en el filtro:
       un paso bajo que se cierra deprisa convierte un triángulo en una
       cuerda pulsada, porque eso es lo que hace una cuerda — suelta los
       armónicos de golpe y se los come en un instante. */
    pizz(f, t, dur, vol) {
      if (!f || !A.ctx || !this.gain) return;
      const o = A.ctx.createOscillator(), g = A.ctx.createGain();
      const lp = A.ctx.createBiquadFilter();
      o.type = 'triangle'; o.frequency.setValueAtTime(f, t);
      lp.type = 'lowpass'; lp.Q.value = 1.4;
      lp.frequency.setValueAtTime(f * 9, t);
      lp.frequency.exponentialRampToValueAtTime(f * 2.1, t + Math.min(0.2, dur));
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(vol, t + 0.006);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(lp).connect(g).connect(this.gain);
      o.start(t); o.stop(t + dur + 0.02);
    },

    /* VIBRÁFONO. Tres senos en armónicos con pesos decrecientes —es lo
       que da el brillo metálico sin sonar a campana de iglesia— y un
       trémolo lento sobre la fundamental, que en el instrumento real lo
       producen los discos girando dentro de los tubos. */
    vibra(f, t, dur, vol) {
      if (!f || !A.ctx || !this.gain) return;
      [[1, 1], [2, 0.3], [4.1, 0.07]].forEach(([mult, peso], i) => {
        const o = A.ctx.createOscillator(), g = A.ctx.createGain();
        o.type = 'sine'; o.frequency.setValueAtTime(f * mult, t);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.linearRampToValueAtTime(vol * peso, t + 0.025);
        g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
        if (i === 0 && dur > 0.5) {
          const lfo = A.ctx.createOscillator(), prof = A.ctx.createGain();
          lfo.frequency.setValueAtTime(4.4, t);
          prof.gain.setValueAtTime(vol * peso * 0.3, t);
          lfo.connect(prof).connect(g.gain);
          lfo.start(t); lfo.stop(t + dur);
        }
        o.connect(g).connect(this.gain);
        o.start(t); o.stop(t + dur + 0.02);
      });
    },

    /* ESCOBILLAS. Ruido paso banda en la zona media, entrando y saliendo
       despacio: es el barrido circular sobre el parche, no un golpe. Sin
       ataque marcado, o vuelve a ser una caja. */
    escobilla(t, dur, vol) {
      if (!A.ctx || !this.gain) return;
      const n = Math.floor(A.ctx.sampleRate * dur);
      const buf = A.ctx.createBuffer(1, n, A.ctx.sampleRate);
      const d = buf.getChannelData(0);
      for (let i = 0; i < n; i++) d[i] = Math.random() * 2 - 1;
      const src = A.ctx.createBufferSource(); src.buffer = buf;
      const f = A.ctx.createBiquadFilter();
      f.type = 'bandpass'; f.frequency.value = 2600; f.Q.value = 0.7;
      const g = A.ctx.createGain();
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(vol, t + dur * 0.45);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      src.connect(f).connect(g).connect(this.gain);
      src.start(t); src.stop(t + dur);
    },

    /* CUERDA PULSADA CORTA, la del ostinato. Es prima del contrabajo de
       la pista de tasación pero mucho más seca y aguda: aquella acompaña
       y esta pregunta. El filtro se cierra más deprisa, que es lo que da
       el «tac» de la uña. */
    cuerda(f, t, dur, vol) {
      if (!f || !A.ctx || !this.gain) return;
      const o = A.ctx.createOscillator(), g = A.ctx.createGain();
      const lp = A.ctx.createBiquadFilter();
      o.type = 'sawtooth'; o.frequency.setValueAtTime(f, t);
      lp.type = 'lowpass'; lp.Q.value = 2.2;
      lp.frequency.setValueAtTime(f * 7, t);
      lp.frequency.exponentialRampToValueAtTime(f * 1.6, t + Math.min(0.12, dur));
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(vol, t + 0.004);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(lp).connect(g).connect(this.gain);
      o.start(t); o.stop(t + dur + 0.02);
    },

    /* CAMPANA. Armónicos no enteros —2,76 y 5,4— que es lo que hace que
       algo suene a metal golpeado y no a flauta. La cola es larga a
       propósito: deja la pregunta en el aire. */
    campana(f, t, dur, vol) {
      if (!f || !A.ctx || !this.gain) return;
      [[1, 1], [2.76, 0.42], [5.4, 0.16]].forEach(([m, peso]) => {
        const o = A.ctx.createOscillator(), g = A.ctx.createGain();
        o.type = 'sine'; o.frequency.setValueAtTime(f * m, t);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.linearRampToValueAtTime(vol * peso, t + 0.006);
        g.gain.exponentialRampToValueAtTime(0.0001, t + dur * (m === 1 ? 1 : 0.55));
        o.connect(g).connect(this.gain);
        o.start(t); o.stop(t + dur + 0.02);
      });
    },

    /* MARIMBA. Es el sonido de pensar, y no es una metáfora: la madera
       golpeada tiene cola corta, así que entre nota y nota queda silencio
       de verdad. El metal —vibráfono, campana— llena ese hueco con su
       propia cola y convierte la duda en suspense.

       El armónico que identifica una marimba es el CUARTO, no el
       segundo: sus tubos resonadores lo refuerzan, y sin él esto suena a
       flauta corta. Va en 3,9 y no en 4 exacto porque las láminas reales
       están afinadas un poco por debajo. */
    madera(f, t, dur, vol) {
      if (!f || !A.ctx || !this.gain) return;
      [[1, 1], [3.9, 0.22], [9.2, 0.05]].forEach(([m, peso]) => {
        const o = A.ctx.createOscillator(), g = A.ctx.createGain();
        o.type = 'sine'; o.frequency.setValueAtTime(f * m, t);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.linearRampToValueAtTime(vol * peso, t + 0.004);
        g.gain.exponentialRampToValueAtTime(0.0001, t + dur * (m === 1 ? 1 : 0.32));
        o.connect(g).connect(this.gain);
        o.start(t); o.stop(t + dur + 0.02);
      });
      /* El golpe de la baqueta: doce milésimas de ruido. Sin él la nota
         «aparece» en vez de ser golpeada. */
      this.ruido(t, 0.012, 2600, vol * 0.45, 1.2);
    },

    /* BLOQUE DE MADERA. Ruido muy filtrado más un seno agudo cortísimo:
       seco, sin cola y sin altura reconocible, para que marque el tiempo
       sin meterse en la armonía. */
    bloque(t, vol) {
      if (!A.ctx || !this.gain) return;
      this.ruido(t, 0.026, 2300, vol, 3.4);
      this.tono(1250, t, 0.032, 'sine', vol * 0.5);
    },

    /* EL PULSO DE RELOJ. Grave, corto y sin cola: no es un bombo de
       batería, es un latido. */
    latido(t, vol) {
      this.tono(74, t, 0.22, 'sine', vol, 40);
    },

    /* RIDE. Como el charles pero con cola: el plato sigue sonando, y esa
       cola es la que sostiene el swing entre golpe y golpe. */
    ride(t, vol) {
      this.ruido(t, 0.34, 7200, vol, 0.8);
      this.ruido(t, 0.09, 3400, vol * 0.5, 1.4);
    },

    caja(t)    { this.ruido(t, 0.13, 1900, this.pista === 'chip' ? 0.12 : 0.20, 0.9); },
    charles(t, fuerte) {
      const v = this.pista === 'chip' ? (fuerte ? 0.045 : 0.025) : (fuerte ? 0.10 : 0.055);
      this.ruido(t, 0.035, 8200, v, 1.6);
    },

    tocar() {
      if (!this.on || !A.ctx || !this.gain) return;
      if (A.ctx.state !== 'running') A.ctx.resume();
      if (this.pista === 'chip') return this.tocarChip();
      if (this.pista === 'mesa') return this.tocarMesa();
      if (this.pista === 'enigma') return this.tocarEnigma();
      this.tocarSalon();
    },

    /* Cuántas semicorcheas dura una sección. Se mide de la melodía, que
       es la voz que manda; el bajo se escribe para cuadrar con ella. */
    largoSeccion(sec) { return sec.melodia.reduce((n, [, d]) => n + d, 0); },

    tocarChip() {
      const t0 = A.ctx.currentTime;
      const S = (60 / this.chip.bpm) / 4;       /* una semicorchea */
      const alto = this.nivel >= 6;
      const { orden, secciones } = this.chip;
      /* A-B-A-C: la vuelta completa son cuatro secciones, así que el
         bucle no se reconoce hasta pasado casi un minuto. */
      const sec = secciones[orden[this.compas % orden.length]];
      const pasos = this.largoSeccion(sec);

      const voz = (pares, toca) => {
        let paso = 0;
        for (const [f, dur] of pares) {
          if (f) toca(f, t0 + paso * S, dur * S, paso);
          paso += dur;
        }
      };

      /* Bajo: pulso ancho, hueco y redondo. */
      voz(sec.bajo, (f, t, d) => this.pulso(f, t, d * 0.9, 0.16, 'ancho', false));

      /* Melodía: las notas cortas se tocan; las largas se arpegian, que
         es lo que suena a consola. */
      voz(sec.melodia, (f, t, d) => {
        if (d >= 0.24 / S) this.arpegio(f, t, d * 0.94, 0.075, sec.acorde);
        else this.pulso(f, t, d * 0.9, 0.085, 'fino', true);
      });

      /* La segunda voz entra solo con racha alta y solo en las secciones
         que aprietan: en la de misterio llenaría justo los huecos que
         hacen que esa sección funcione. */
      if (alto && sec.percusion !== 'suelta') {
        voz(sec.melodia, (f, t, d) => {
          if (d >= 4) this.pulso(f * 0.5, t, d * S * 0.9, 0.03, 'medio', true);
        });
      }

      /* PERCUSIÓN POR SECCIÓN. Antes sonaba igual todo el rato y era la
         mitad de la sensación de bucle; ahora entra y sale con la
         música. */
      const golpe = (i) => t0 + i * S;
      if (sec.percusion === 'suelta') {
        /* Solo el pulso del compás: deja respirar. */
        for (let c = 0; c < pasos / 16; c++) this.bombo(golpe(c * 16));
      } else if (sec.percusion === 'media') {
        for (let c = 0; c < pasos / 16; c++) {
          const b = c * 16;
          this.bombo(golpe(b)); this.caja(golpe(b + 8));
          for (let i = 0; i < 16; i += 4) this.charles(golpe(b + i), i === 0);
        }
      } else {
        for (let c = 0; c < pasos / 16; c++) {
          const b = c * 16;
          this.bombo(golpe(b)); this.bombo(golpe(b + 8));
          this.caja(golpe(b + 4)); this.caja(golpe(b + 12));
          for (let i = 0; i < 16; i += 2) this.charles(golpe(b + i), i % 8 === 0);
          if (alto && c % 2 === 1) { this.caja(golpe(b + 14)); this.caja(golpe(b + 15)); }
        }
      }
      this.compas++;
    },

    /* EL SWING, que es lo que hace que esto no suene a cuadrícula.
       Devuelve la hora de la corchea `i`: las de contratiempo no caen a
       la mitad del tiempo sino al 62 %, así que llegan tarde y perezosas.
       Todo lo que suena en esta pista pasa por aquí, percusión incluida:
       si la batería va recta y el bajo va con swing, se pelean. */
    horaSwing(t0, i, T) {
      return t0 + (Math.floor(i / 2) + (i % 2 ? this.mesa.swing : 0)) * T;
    },

    tocarEnigma() {
      const t0 = A.ctx.currentTime;
      const T = 60 / this.enigma.bpm;               /* una negra */
      const C = T * 0.5;                            /* una corchea */
      const { orden, secciones } = this.enigma;
      const sec = secciones[orden[this.compas % orden.length]];
      const alto = this.nivel >= 6;

      sec.compases.forEach((c, nc) => {
        const base = t0 + nc * 4 * T;

        /* El bajo pulsado dice dónde está la armonía y nada más. Corto:
           si se tiende, deja de ser un apoyo y empieza a empujar. */
        (c.bajo || []).forEach((f, i) => {
          if (f) this.pizz(f, base + i * T, T * 0.7, 0.20);
        });

        /* LA FRASE. Cada nota lleva escrito cuándo entra y cuánto dura,
           así que los silencios son parte de la melodía y no lo que queda
           entre notas. La marimba suena algo más de lo que dura la nota
           en el papel —las láminas siguen vibrando— y de ahí el 1,9. */
        (c.frase || []).forEach(([f, pos, largo]) => {
          this.madera(f, base + pos * C, largo * C * 1.9, 0.115);
          /* Con racha alta, la octava por encima muy floja: la misma
             pregunta dicha con más filo, sin subir el volumen. */
          if (alto) this.madera(f * 2, base + pos * C + 0.012, largo * C * 0.8, 0.020);
        });

        /* El acorde al aire, solo en el hueco: ahí no hay frase que
           tapar y es lo que impide que los dos compases suenen a error. */
        (c.aire || []).forEach(f => this.vibra(f, base, 4 * T * 0.85, 0.030));

        /* La madera seca: el tiempo pasando, sin dramatizarlo. El golpe
           del primer tiempo pesa más que los de contratiempo. */
        (sec.bloques || []).forEach(i => this.bloque(base + i * C, i % 4 === 0 ? 0.050 : 0.032));
        (sec.latir || []).forEach(i => this.latido(base + i * T, i === 0 ? 0.26 : 0.17));
        if (alto && sec.aprieta) {
          for (let i = 1; i < 8; i += 2) this.charles(base + i * C, false);
        }
      });
      this.compas++;
    },

    tocarMesa() {
      const t0 = A.ctx.currentTime;
      const T = 60 / this.mesa.bpm;             /* una negra */
      const { orden, secciones } = this.mesa;
      const sec = secciones[orden[this.compas % orden.length]];
      const alto = this.nivel >= 6;

      sec.compases.forEach((c, nc) => {
        const base = t0 + nc * 4 * T;

        /* Bajo caminante: una negra por tiempo, sin adornos. Es la voz
           que lleva la pieza, y por eso es la más alta de las tres. */
        c.bajo.forEach((f, i) => { if (f) this.pizz(f, base + i * T, T * 0.92, 0.30); });

        /* Acordes: uno al empezar el compás, o dos si el compás cambia
           de armonía a la mitad. Las notas se abren con unos milisegundos
           de diferencia porque una mano no cae de golpe. */
        c.voz.forEach((acorde, k) => {
          const t = base + (c.voz.length > 1 ? k * 2 * T : 0);
          const dur = (c.voz.length > 1 ? 2 : 4) * T * 0.9;
          acorde.forEach((f, j) => this.vibra(f, t + j * 0.018, dur, 0.055));
        });
      });

      /* Melodía: notas sueltas de vibráfono, con huecos largos a
         propósito. Va por corcheas con swing, como todo lo demás. */
      let paso = 0;
      for (const [f, dur] of sec.melodia) {
        if (f) {
          const t = this.horaSwing(t0, paso, T);
          this.vibra(f, t, this.horaSwing(t0, paso + dur, T) - t, 0.075);
          /* Con racha alta, la octava de arriba muy floja: no es una voz
             nueva, es la misma con más brillo. */
          if (alto) this.vibra(f * 2, t + 0.03, T * dur * 0.4, 0.016);
        }
        paso += dur;
      }

      /* ESCOBILLAS Y PLATO, por sección.
         El barrido de escobilla suena en todas —es la cama sobre la que
         se apoya el resto— y el plato entra según cuánto aprieta la
         sección. El patrón de swing del ride es el de toda la vida:
         negra, negra + corchea atrasada. */
      const compases = sec.compases.length;
      for (let c = 0; c < compases; c++) {
        const b = c * 8;                        /* ocho corcheas por compás */
        this.escobilla(t0 + c * 4 * T, 4 * T, sec.ritmo === 'nada' ? 0.016 : 0.028);
        if (sec.ritmo === 'nada') continue;
        const golpes = sec.ritmo === 'escobilla' ? [2, 6]
                     : sec.ritmo === 'ride'      ? [0, 2, 3, 4, 6, 7]
                     : [0, 2, 3, 4, 6, 7];
        golpes.forEach(i => this.ride(this.horaSwing(t0, b + i, T),
                                      i % 4 === 0 ? 0.055 : 0.032));
        /* En la sección más movida, un golpe seco al cerrar el compás. */
        if (sec.ritmo === 'llena' && c % 2 === 1) {
          this.escobilla(this.horaSwing(t0, b + 7, T), T * 0.5, 0.05);
        }
      }
      this.compas++;
    },

    tocarSalon() {
      const t0 = A.ctx.currentTime;
      const ac = this.prog[this.compas % 4];
      const T = 0.5555;                 /* un tiempo a 108 ppm */
      const alto = this.nivel >= 5;
      const relleno = (this.compas % 4) === 3;

      this.bombo(t0);
      this.bombo(t0 + T * 2);
      if (alto) this.bombo(t0 + T * 2.5);
      this.caja(t0 + T);
      this.caja(t0 + T * 3);
      const golpes = alto ? 16 : 8;
      for (let i = 0; i < golpes; i++) {
        this.charles(t0 + i * (T * 4 / golpes), i % (golpes / 4) === 0);
      }
      if (relleno) {
        this.caja(t0 + T * 3.5);
        this.caja(t0 + T * 3.75);
      }

      this.tono(ac.raiz, t0, 0.42, 'triangle', 0.34);
      this.tono(ac.raiz, t0 + T * 1.5, 0.28, 'triangle', 0.22);
      this.tono(ac.raiz, t0 + T * 2, 0.34, 'triangle', 0.28);
      this.tono(ac.paso, t0 + T * 3.5, 0.26, 'triangle', 0.24);

      ac.notas.slice(0, 3).forEach(f => this.tono(f, t0, 2.1, 'sine', 0.055));

      const pasos = alto ? 8 : 4;
      for (let i = 0; i < pasos; i++) {
        const f = ac.notas[i % ac.notas.length];
        this.tono(f, t0 + i * (T * 4 / pasos), 0.2, 'sine', 0.075);
        if (alto) this.tono(f * 2, t0 + i * (T * 4 / pasos) + 0.06, 0.14, 'sine', 0.032);
      }

      this.compas++;
    },

    intensidad(racha) { this.nivel = racha || 0; },
    parar() {
      this.on = false; this.quiere = false; this.nivel = 0;
      this.cortar();
    }
  };

  /* EL INTERRUPTOR DE SILENCIO DEL TELÉFONO.

     En iOS el interruptor lateral silencia el audio web, y no hay forma
     de saberlo desde la página: el jugador activa el sonido, no oye
     nada y da por hecho que el juego está roto. Safari 16.4 añadió
     `navigator.audioSession.type`; con `playback` el audio se trata como
     reproducción de contenido y **suena aunque el teléfono esté en
     silencio**, que es justo lo que hace falta aquí.
     Donde no exista, no hay nada que hacer desde web: por eso la
     pantalla de inicio lleva el aviso, antes de la partida y no en
     mitad de ella.

     Además, ningún navegador deja sonar nada hasta que el visitante
     toca la página. Se engancha al PRIMER gesto, sea cual sea, en vez de
     esperar a un botón concreto. */
  /* NINGÚN NAVEGADOR DEJA SONAR NADA HASTA QUE SE TOCA LA PÁGINA.

     Es una protección de todos los navegadores desde 2018 y no hay forma
     de saltarla: el AudioContext nace suspendido y solo se reanuda
     dentro de un gesto del visitante. Así que el sonido puede venir
     encendido —y viene—, pero no empieza a oírse hasta el primer toque.

     Lo que sí estaba mal era decir «activado» mientras todavía no podía
     sonar: el botón prometía algo que no pasaba y el juego parecía roto.
     Ahora la interfaz distingue tres estados —silenciado, encendido
     esperando el primer toque, y sonando— y lo dice.

     Tres arreglos sobre la versión anterior:
     · Se REINTENTA en cada gesto mientras el contexto no esté corriendo.
       Antes el listener era `once` y marcaba «despierto» antes de saber
       si había funcionado: si el primer intento fallaba, no había
       segundo.
     · Se escucha `pointerup`, `touchend` y `click` además de los de
       bajada. En Safari de iPhone, `touchstart` y `pointerdown` NO
       cuentan siempre como activación; `touchend` y `click` sí.
     · «Despierto» significa que el contexto está en `running`, no que se
       haya intentado. */
  let audioDespierto = false;
  /* Cuándo empezó a sonar. Hace falta porque el gesto que despierta el
     audio es el mismo que pulsa el botón: el oyente global va en
     `pointerdown` y el del botón en `click`, así que para cuando corre el
     segundo el audio ya está en marcha y preguntar «¿suena?» siempre
     responde que sí. Con la marca se distingue «llevaba sonando» de
     «acaba de arrancar con este mismo toque». */
  let audioDesde = 0;
  function audioSuena() { return !!(A.ctx && A.ctx.state === 'running'); }
  /* Un gesto entero —bajada, subida y click— cabe de sobra en 800 ms. */
  function reciénDespierto() { return audioDesde > 0 && (Date.now() - audioDesde) < 800; }

  function despertarAudio() {
    if (audioDespierto && audioSuena()) return;
    /* `playback` SOLO con la página a la vista. Fuera de ella vuelve a
       `auto` en `callarFuera`, o iOS mantiene el audio vivo en segundo
       plano como si fuera un reproductor de música. */
    if (document.hidden) return;
    tipoSesion('playback');
    A.boot();
    if (!A.ctx) return;
    const seguir = () => {
      if (!audioSuena()) return;
      if (!audioDespierto) audioDesde = Date.now();
      audioDespierto = true;
      if (M.quiere && !M.on) M.arrancar();
      pintarAudio();
      avisarSonido();
    };
    /* CUALQUIER ESTADO QUE NO SEA `running` SE REANUDA, no solo
       `suspended`. Safari tiene un tercer estado, **`interrupted`**, al
       que pasa cuando el sistema le quita el audio —otra app, una
       llamada, volver de segundo plano—, y comparando solo contra
       `suspended` el código caía en la rama del `else`, veía que no
       sonaba y se rendía sin intentar nada. Es por lo que la música no
       volvía al recuperar la pestaña.
       Y si el contexto quedó cerrado, se hace uno nuevo: uno cerrado no
       se reabre. */
    if (A.ctx.state === 'closed') { A.ctx = null; A.boot(); if (!A.ctx) return; }
    if (A.ctx.state !== 'running') A.ctx.resume().then(seguir).catch(() => {});
    else seguir();
  }
  /* Sin `once`: cada gesto es otra oportunidad, y en cuanto suena la
     comprobación de arriba los vuelve gratuitos. */
  ['pointerdown', 'touchstart', 'pointerup', 'touchend', 'click', 'keydown'].forEach(ev =>
    document.addEventListener(ev, despertarAudio, { passive: true }));

  /* ============================================================
     EL AUDIO MUERE CON LA PÁGINA
     ============================================================ */
  /* Leonardo lo reportó así: «la música se queda atorada aunque cierres
     la página y sigue sonando en el teléfono». Es real y tenía dos
     causas que se sumaban:

     1. `navigator.audioSession.type = 'playback'`. Se puso para que el
        juego suene con el interruptor de silencio del iPhone puesto, y
        hace su trabajo — pero le dice al sistema que esto es
        REPRODUCCIÓN DE CONTENIDO, la misma categoría que un reproductor
        de música. Y a un reproductor iOS lo deja sonando cuando sales de
        la app. Es decir: el ajuste que arregló una cosa causó la otra.
     2. Nadie suspendía el contexto al salir. Web Audio agenda cada nota
        con su hora de arranque; si la pestaña se oculta y el contexto
        sigue corriendo, las notas ya puestas siguen sonando aunque el
        `setTimeout` que programa la siguiente vuelta no vuelva a correr.

     Se arregla sin renunciar a lo uno ni a lo otro: **`playback` solo
     mientras la página está a la vista**. Al ocultarse vuelve a `auto`,
     se corta la pista y se SUSPENDE el contexto, que es lo que para el
     reloj del audio y calla lo que ya estaba agendado. Al volver, el
     audio se recupera solo.

     Y al salir de verdad se CIERRA el contexto. `pagehide` y no
     `beforeunload`: en Safari de iPhone el segundo no se dispara al
     cerrar la pestaña ni al cambiar de app, y era justo el caso del
     reporte. */
  let dormidoFuera = false;

  function tipoSesion(t) {
    try { if (navigator.audioSession) navigator.audioSession.type = t; } catch (e) {}
  }

  /* Callar sin tocar la preferencia del jugador: `M.quiere` es lo que él
     decidió y no se toca aquí. `M.on` sí, porque `arrancar()` se planta
     si lo encuentra en true y entonces no habría vuelta. */
  function callarFuera() {
    tipoSesion('auto');
    M.cortar();
    M.on = false;
    audioDespierto = false; audioDesde = 0;
    if (A.ctx && A.ctx.state === 'running') { try { A.ctx.suspend(); } catch (e) {} }
  }

  function cerrarAudio() {
    callarFuera();
    if (A.ctx) { try { A.ctx.close(); } catch (e) {} A.ctx = null; }
    M.gain = null;
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      dormidoFuera = M.quiere;
      callarFuera();
    } else if (dormidoFuera) {
      dormidoFuera = false;
      /* Al volver, tres intentos espaciados en vez de uno. `resume()`
         fuera de un gesto funciona en cuanto el contexto se desbloqueó
         una vez en esta página, pero al recuperar la pestaña el sistema
         todavía puede estar devolviendo el audio y el primer intento
         llega demasiado pronto: se resuelve y el contexto sigue sin
         correr. Tres tiros bastan, y si aun así no arranca, el primer
         toque en la pantalla lo recupera. */
      despertarAudio();
      setTimeout(despertarAudio, 250);
      setTimeout(despertarAudio, 900);
    }
  });

  /* Irse de la página: cerrar del todo. Con `persisted` la página se
     guarda para el botón «atrás», así que se deja el contexto vivo pero
     suspendido; cerrarlo dejaría la página sin audio al volver. */
  window.addEventListener('pagehide', e => {
    if (e.persisted) callarFuera(); else cerrarAudio();
  });
  window.addEventListener('pageshow', e => {
    if (e.persisted && M.quiere) despertarAudio();
  });

  /* EL AVISO DE LA PORTADA, que cambia según lo que pase de verdad:

     · mientras no se haya tocado nada, dice que el sonido arranca al
       tocar — que es la verdad y evita que parezca averiado;
     · en un iPhone sin `navigator.audioSession` (Safari anterior al
       16.4) avisa además del interruptor de silencio, que deja el audio
       mudo sin que la página pueda enterarse;
     · cuando ya suena, desaparece.

     Va en la portada y nunca en mitad de una partida. */
  function avisarSonido() {
    const nota = $('ce-lifenote');
    if (!nota) return;
    let p = nota.querySelector('.avsil');
    const sonando = audioSuena();
    const mudos = !A.on && !M.quiere;
    if ((sonando && !soportaSilencio()) || mudos) { if (p) p.remove(); return; }
    if (!p) {
      p = document.createElement('span');
      p.className = 'avsil';
      p.style.cssText = 'display:block;margin-top:5px';
      nota.appendChild(p);
    }
    p.innerHTML = !sonando
      ? 'El juego tiene sonido. <b>Toca la pantalla para que empiece.</b>'
      : 'El juego tiene sonido. <b>Si no oyes nada, quita el silencio del teléfono.</b>';
  }
  /* El interruptor de silencio solo es un problema en iPhone, y solo
     donde no existe la API que lo desactiva. En Android el volumen de
     medios es independiente. */
  function soportaSilencio() {
    return !navigator.audioSession && window.matchMedia && matchMedia('(pointer:coarse)').matches;
  }

  /* Los botones dicen lo que HARÁN al pulsarlos, y como el sonido viene
     encendido, lo que harán es silenciar. */
  const ICO_SND = {
    on:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/></svg>',
    off: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>'
  };
  /* TRES ESTADOS, no dos: silenciado, encendido pero esperando el
     primer toque, y sonando. El intermedio existe porque el navegador no
     deja sonar nada antes de que se toque la página, y pintarlo igual
     que «sonando» es lo que hacía parecer que el juego estaba roto.
     Se distingue con la clase `esperando`, que atenúa el botón y le pone
     un punto. */
  function pintarAudio() {
    const bs = $('ce-snd'), bm = $('ce-mus');
    const listo = audioSuena();
    const pinta = (b, quiere, cosa) => {
      b.classList.toggle('on', quiere && listo);
      b.classList.toggle('esperando', quiere && !listo);
      b.setAttribute('aria-pressed', String(quiere));
      b.setAttribute('aria-label',
        !quiere ? 'Activar ' + cosa
        : listo ? 'Silenciar ' + cosa
        : cosa.charAt(0).toUpperCase() + cosa.slice(1) + ' lista: toca la pantalla para oírla');
      b.title = b.getAttribute('aria-label');
    };
    bs.innerHTML = A.on ? ICO_SND.on : ICO_SND.off;
    pinta(bs, A.on, 'efectos');
    pinta(bm, M.quiere, 'música');
  }

  pintarAudio();

  /* ============================================================
     EFECTOS VISUALES
     ============================================================ */
  function flotar(txt, oro) {
    const h = $('ce-stage'); if (!h) return;
    const e = document.createElement('span');
    e.className = 'flot' + (oro ? ' oro' : ''); e.textContent = txt; e.setAttribute('aria-hidden', 'true');
    h.appendChild(e);
    e.addEventListener('animationend', () => e.remove(), { once: true });
    setTimeout(() => e.remove(), 1400);
  }
  /* Un momento es una pantalla entera a carbon que tapa la partida un
     segundo. Sustituye al aviso que antes flotaba sobre la imagen y que
     se perdía justo cuando había algo que celebrar: encima de una foto,
     con tres opciones debajo y doce segundos corriendo, nadie lo leía.

     Que el fondo cambie de claro a oscuro ES el aviso. No hace falta
     nada más, y es lo que da carácter: el resto del juego vive en
     blanco, así que el negro solo aparece cuando pasa algo. */
  const ICO = {
    mult: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    racha: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22c4.4 0 7-2.8 7-6.4 0-3.8-3-5.6-3.6-9.6-1.9 1.3-2.6 3.2-2.6 4.6 0 1-.5 1.6-1.2 1.6-.8 0-1.3-.7-1.3-1.9 0-1 .2-2 .5-2.8C8.6 9 7 11.6 7 14.8 7 19 9.6 22 12 22z"/></svg>',
    record: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4h10v5a5 5 0 0 1-10 0V4z"/><path d="M7 6H4v1a3 3 0 0 0 3 3M17 6h3v1a3 3 0 0 1-3 3M9 20h6M12 14v6"/></svg>',
    grial: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l2.6 5.6 6.1.8-4.5 4.2 1.2 6-5.4-3-5.4 3 1.2-6L3.3 9.4l6.1-.8z"/></svg>',
    corona: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 8l4 3.4L12 4l5 7.4L21 8l-1.5 9.8a1 1 0 0 1-1 .85H5.5a1 1 0 0 1-1-.85L3 8z"/><circle cx="3" cy="6.3" r="1.7"/><circle cx="12" cy="2.5" r="1.8"/><circle cx="21" cy="6.3" r="1.7"/></svg>'
  };
  let momAbierto = null;
  function momento(o) {
    /* Solo uno a la vez: dos momentos encadenados se pisan y el segundo
       aparece a medio gesto del primero. */
    if (momAbierto) { momAbierto.remove(); momAbierto = null; }
    const e = document.createElement('div');
    e.className = 'mom ' + (o.tono || 'pu');
    e.setAttribute('role', 'status');
    const in_ = document.createElement('div'); in_.className = 'in';
    if (o.anillo) { const a = document.createElement('span'); a.className = 'anillo'; a.setAttribute('aria-hidden','true'); in_.appendChild(a); }
    if (o.ico) { const i = document.createElement('span'); i.className = 'ic'; i.setAttribute('aria-hidden','true'); i.innerHTML = ICO[o.ico] || ''; in_.appendChild(i); }
    if (o.et) { const k = document.createElement('p'); k.className = 'et'; k.textContent = o.et; in_.appendChild(k); }
    if (o.big) { const g = document.createElement('p'); g.className = 'big' + (o.cuenta ? ' cd' : ''); g.textContent = o.big; in_.appendChild(g); }
    if (o.tit) { const t = document.createElement('p'); t.className = 'tit'; t.textContent = o.tit; in_.appendChild(t); }
    if (o.sub) { const sb = document.createElement('p'); sb.className = 'sub'; sb.textContent = o.sub; in_.appendChild(sb); }
    e.appendChild(in_);
    raiz.appendChild(e);
    momAbierto = e;
    setTimeout(() => { if (momAbierto === e) { e.remove(); momAbierto = null; } }, o.ms || 1100);
  }
  function toast(txt) {
    const e = document.createElement('div');
    e.className = 'toast'; e.setAttribute('role', 'status'); e.textContent = txt;
    raiz.appendChild(e);
    e.addEventListener('animationend', () => e.remove(), { once: true });
    setTimeout(() => e.remove(), 3000);
  }

  /* ============================================================
     PINTADO
     ============================================================ */
  /* Los corazones de vidas viven en el encabezado, que se ve en TODAS
     las pantallas; pintarlos solo dentro de `pintarHome` los dejaba
     congelados durante la partida y en el resultado. El servidor
     descontaba bien —se comprobó en la base de datos— pero quien
     terminaba una partida seguía viendo tres y creía que no se le
     había restado nada. Ahora se repinta en cada cambio de estado. */
  const CORAZON = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20.8l-1.5-1.35C5.15 14.63 2 11.79 2 8.3 2 5.46 4.24 3.2 7.05 3.2c1.6 0 3.13.74 4.12 1.92l.83.98.83-.98A5.48 5.48 0 0 1 16.95 3.2C19.76 3.2 22 5.46 22 8.3c0 3.49-3.15 6.33-8.5 11.16L12 20.8z"/></svg>';

  /* Los corazones se dibujan TODOS: la vida gastada se queda como
     silueta en vez de desaparecer. Si desapareciera, el chip cambiaría
     de ancho al perder una y el bloque entero daría un salto. */
  /* `progreso` (0..1) rellena el PRIMER corazón vacío, que es el que está
     por llegar. Sin eso el jugador ve tres siluetas iguales y no sabe si
     la siguiente está a un minuto o a dos horas: el relleno es la única
     parte que se entiende de un vistazo, sin leer el reloj. */
  function pintarCorazones(caja, vivas, total, progreso) {
    if (!caja) return;
    caja.textContent = '';
    for (let i = 0; i < total; i++) {
      const c = document.createElement('span');
      if (i < vivas) {
        c.className = 'viva'; c.innerHTML = CORAZON;
      } else if (i === vivas && progreso > 0) {
        c.className = 'cargando';
        c.innerHTML = '<span class="base">' + CORAZON + '</span>'
                    + '<span class="fill">' + CORAZON + '</span>';
        c.style.setProperty('--p', Math.round(Math.min(1, progreso) * 100) + '%');
      } else {
        c.className = 'ida'; c.innerHTML = CORAZON;
      }
      caja.appendChild(c);
    }
    caja.setAttribute('aria-label', vivas + ' de ' + total + ' vidas');
  }

  /* CUÁNTO FALTA PARA LA SIGUIENTE VIDA.

     El servidor manda los milisegundos que faltan, no una hora: así el
     navegador no depende de que su reloj esté bien, que en un teléfono
     pasa más de lo que parece. De ahí se descuenta en local y se refresca
     cada diez segundos; pedirle la cuenta al servidor cada segundo sería
     una petición por segundo y por jugador. */
  /* Por debajo de una hora se enseñan los SEGUNDOS, y no es un capricho:
     un reloj que se mueve es lo que convierte «vuelve luego» en «espero».
     Por encima no, porque ver 1:47:33 no ayuda a decidir nada y obliga a
     repintar sesenta veces por minuto para nada. */
  function faltaTexto(ms) {
    if (ms == null || ms <= 0) return '';
    const t = Math.ceil(ms / 1000);
    if (t < 3600) {
      const m = Math.floor(t / 60), sg = t % 60;
      return m + ':' + String(sg).padStart(2, '0');
    }
    /* FLOOR Y NO ROUND: con `round`, a 1 h 59 min 50 s el resto de la hora
       redondea a 60 y el reloj escribe «1 h 60 min», que sale en pantalla
       los primeros 30 segundos de cada espera de dos horas. Con `floor`
       el texto dice siempre «falta al menos esto», que además es lo que
       hace arriba `ceil` con los segundos. */
    const h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60);
    return m ? h + ' h ' + m + ' min' : h + ' h';
  }

  /* EL CHIP DE VIDAS, que es donde el jugador mira.

     Tres estados y cada uno dice una cosa distinta:
     · lleno      → «Completo», en verde, sin reloj que mirar.
     · a medias   → el reloj de la siguiente, en rojo discreto.
     · sin vidas  → el chip entero se tiñe y el reloj crece: en ese momento
                    es la única información que importa en la pantalla.
     El rótulo ya no dice «Vidas de hoy» porque dejaron de ser de hoy. */
  function chipVidas() {
    const d = S.datos; if (!d) return;
    const tope = d.intentosTotal || 3;
    const chip = $('ce-chipvidas'), rot = $('ce-vidasrot'), t = $('ce-vidatimer');
    const lleno = d.intentos >= tope;
    const falta = faltaTexto(S.vidaEn);

    /* El progreso del corazón que viene sale de cuánto queda frente a lo
       que dura una recarga entera. */
    const dura = d.recargaMs || 7200000;
    const prog = (!lleno && S.vidaEn != null) ? 1 - Math.min(1, S.vidaEn / dura) : 0;
    pintarCorazones($('ce-vidas'), d.intentos, tope, prog);

    if (chip) chip.classList.toggle('vacio', d.intentos <= 0);
    if (rot)  rot.textContent = d.intentos <= 0 ? 'Sin vidas' : 'Vidas';
    if (!t) return;
    if (lleno) { t.textContent = 'Completo'; t.className = 'recarga lleno'; return; }
    t.className = 'recarga';
    t.textContent = !falta ? ''
      : (d.intentos <= 0 ? 'Siguiente en ' + falta : '+1 en ' + falta);
  }

  /* La nota de abajo deja de llevar el reloj y explica la regla una vez:
     el dato vivo vive arriba, con los corazones. */
  function notaVidas() {
    const d = S.datos; if (!d) return;
    chipVidas();
    const nota = $('ce-lifenote'); if (!nota) return;
    nota.textContent = 'Se recupera una vida cada 2 horas, hasta '
      + (d.intentosTotal || 3) + '.';
  }

  /* Un solo temporizador para todo el juego: descuenta lo que falta y
     repinta. Cuando la espera llega a cero pide el estado una vez, que es
     el momento en que de verdad hay una vida nueva. */
  /* UN TIC POR SEGUNDO, UNA PETICIÓN POR VIDA.

     El descuento es local —el servidor mandó los milisegundos que
     faltaban— y solo se le pregunta cuando la cuenta llega a cero, que es
     el único instante en que de verdad hay una vida nueva. Un reloj a un
     segundo con peticiones a un segundo sería una por jugador y segundo. */
  function relojVidas() {
    clearInterval(S.tVida);
    S.tVida = setInterval(async () => {
      if (S.vidaEn == null) return;
      S.vidaEn -= 1000;
      if (S.vidaEn <= 0) {
        S.vidaEn = null;
        try {
          S.datos = await api('/estado');
          S.vidaEn = S.datos.proximaVidaEn;
          pintarIntentos();
          A.good && A.good(2);        /* una vida que llega se oye */
        } catch (e) {}
      }
      chipVidas();
      const b = $('ce-again');
      if (b && S.datos && S.datos.intentos > 0) {
        b.disabled = false; b.textContent = 'Otra partida';
      }
    }, 1000);
  }

  function pintarIntentos() {
    const d = S.datos;
    if (!d) return;
    const box = $('ce-lives');
    box.textContent = '';
    const lab = document.createElement('span');
    lab.className = 'lab'; lab.textContent = 'Vidas';
    box.appendChild(lab);
    const cor = document.createElement('span');
    cor.className = 'corazones';
    box.appendChild(cor);
    const dura = d.recargaMs || 7200000;
    const prog = (d.intentos < d.intentosTotal && S.vidaEn != null)
      ? 1 - Math.min(1, S.vidaEn / dura) : 0;
    pintarCorazones(cor, d.intentos, d.intentosTotal, prog);
  }

  function pintarHome() {
    const d = S.datos;
    pintarAudio();
    $('ce-pts').textContent = num(d.puntos) + ' pts';
    const prox = d.premios.find(p => p.pts > d.puntos);
    const alc = d.premios.filter(p => p.pts <= d.puntos);
    if (prox) {
      const desde = alc.length ? alc[alc.length - 1].pts : 0;
      $('ce-bar').style.width = Math.max(0, Math.min(100, ((d.puntos - desde) / (prox.pts - desde)) * 100)).toFixed(1) + '%';
      $('ce-rwtxt').innerHTML = alc.length
        ? 'Ya puedes canjear <b>' + alc[alc.length - 1].n + '</b>. Con ' + num(prox.pts - d.puntos) + ' pts más llegas a ' + prox.n + '.'
        : 'Te faltan <b>' + num(prox.pts - d.puntos) + ' pts</b> para ' + prox.n + ', válido en compras desde ' + dinero(prox.min) + '.';
    } else {
      $('ce-bar').style.width = '100%';
      $('ce-rwtxt').innerHTML = 'Tienes puntos para <b>cualquier recompensa del catálogo</b>.';
    }

    pintarIntentos();
    /* El contador se resincroniza con lo que acaba de decir el servidor:
       el descuento local es solo para que el número se mueva entre
       peticiones, no una fuente de verdad. */
    S.vidaEn = d.proximaVidaEn != null ? d.proximaVidaEn : null;
    notaVidas();
    relojVidas();

    /* MEJOR RACHA, que es de lo que habla el juego. El chip enseñaba los
       días seguidos entrando bajo ese rótulo, y son otra cosa: ahora los
       días bajan a línea de apoyo, donde sí se entienden. */
    $('ce-rachan').textContent = (d.mejorRacha || 0) + (d.mejorRacha === 1 ? ' acierto' : ' aciertos');
    $('ce-rachad').textContent = d.rachaDias > 1
      ? d.rachaDias + ' días seguidos jugando'
      : (d.rachaDias === 1 ? 'Primer día de racha' : '');
    /* Los corazones del chip los pinta `chipVidas`, que es quien sabe el
       progreso de la siguiente. Repintarlos aquí los dejaba planos. */

    /* EL AVISO DEL BOLETÍN, solo a quien no lo ha decidido. A quien dijo
       que no NO se le vuelve a preguntar: insistir es lo que convierte un
       «no» en una queja de spam, y una queja cuesta más que un correo. */
    const pts = d.boletinPuntos || 500;
    texto('ce-nom-bol-p', '+' + num(pts) + ' puntos');
    texto('ce-bolhome-p', 'Y te llevas ' + num(pts) + ' puntos.');
    tapar('ce-bolhome', d.boletinDecidido !== false);

    document.querySelectorAll('#ce-modes .mode').forEach(b => {
      const modo = b.dataset.mode;
      const hay = (d.modos && d.modos[modo]) || 0;
      /* MANTENIMIENTO: solo afecta al reto de precios, que es el único
         que depende de cifras que se refrescan. Los otros dos siguen
         jugables — parar el juego entero por actualizar un catálogo de
         precios sería castigar a quien viene a otra cosa. */
      const enObras = modo === 'precio' && d.mantenimiento;
      b.disabled = d.intentos <= 0 || hay === 0 || enObras;
      b.classList.toggle('obras', !!enObras);
      const sub = b.querySelector('.tx > span:last-child');
      if (enObras && sub) sub.textContent = 'Actualizando precios de mercado. Vuelve en un rato.';
      else if (hay === 0 && sub) sub.textContent = 'Todavía no hay piezas para este reto.';
      /* La foto de fondo sale del catálogo ya cargado: una pieza real de
         ese reto, desenfocada por el propio recorte. Con icono lineal la
         tarjeta se lee y se ignora; con foto se toca. Si el servidor no
         da muestra, queda el carbon y no se rompe nada. */
      const im = $('ce-mfoto-' + modo);
      if (im && !im.src && d.muestras && d.muestras[modo]) {
        im.src = d.muestras[modo];
        im.addEventListener('error', () => { im.remove(); }, { once: true });
      }
    });

    pintarSelectores();
    arrancarCuenta();
    pintarTabla($('ce-boardmini'), 5);
    pintarAnuncio($('ce-admini'));
    avisarSonido();   /* al final: arriba se reescribe `ce-lifenote` */
  }

  const CORONA = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 8l4 3.4L12 4l5 7.4L21 8l-1.5 9.8a1 1 0 0 1-1 .85H5.5a1 1 0 0 1-1-.85L3 8z"/><circle cx="3" cy="6.3" r="1.7"/><circle cx="12" cy="2.5" r="1.8"/><circle cx="21" cy="6.3" r="1.7"/></svg>';
  /* El tercero no lleva corona sino un galón: una corona pequeña ya la
     tiene el segundo, y tres coronas iguales no dirían quién va delante. */
  const GALON = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 4l8 9H4l8-9z"/></svg>';
  /* El rótulo nombra el puesto con palabras porque el número ya está
     arriba de la tarjeta: repetir «1.º» debajo de un «01» es decir dos
     veces lo mismo y desperdiciar la única línea que puede dar tono. */
  const PL = { 1: 'Primer lugar', 2: 'Segundo lugar', 3: 'Tercer lugar' };

  /* La inicial del nombre como avatar. No hay fotos de jugador y pedirlas
     sería otra fricción; una letra sobre color sólido distingue igual y
     es lo que hace la maqueta. */
  const inicial = n => (String(n || '?').trim()[0] || '?').toUpperCase();

  /* ============================================================
     AVATARES

     Doce dibujos de la casa y ninguna foto subida por el jugador. En una
     tabla pública, dejar subir imágenes obliga a moderarlas y basta una
     para tener un problema con la marca al lado. Con una lista cerrada
     el jugador se distingue igual y no hay nada que revisar.

     El vocabulario es el del oficio —carta, slab, sobre, lupa, guante—
     más los cuatro de rareza que la casa ya usa. El servidor guarda solo
     la clave y valida que exista; el dibujo vive aquí.
     ============================================================ */
  /* Los colores del círculo. Lista cerrada y no un selector libre: en una
     tabla pública, un color a mano permite copiar el fondo con el que se
     resalta «tu fila» y hacerse pasar por otro, y además rompe el
     contraste del dibujo encima. Estos salen de la paleta de la casa y
     están calculados para que el dibujo se lea en claro y en oscuro. */
  /* DIEZ COLORES QUE SE DISTINGUEN DE VERDAD.

     Los de antes eran diez nombres y cinco colores: púrpura y lila iban
     a 262° y 282°, oro y ámbar a 46° y 38°, rojo y rosa a 356° y 336°, y
     carbon y gris eran los dos neutros oscuros. Elegir entre ellos en un
     círculo de 40 px no es elegir. Leonardo lo dijo tal cual: «son muy
     parecidos, deben ser totalmente distintos».
     Ahora ninguno está a menos de 22° de su vecino y los dos neutros se
     separan por claridad. Todos pasan de 4.5:1 con el dibujo en blanco,
     medido, porque el círculo lleva el dibujo encima.
     Las CLAVES no cambian aunque el color sí: hay fichas guardadas con
     `lila` y `ambar`, y renombrarlas dejaría a esa gente sin color.
     El segundo tono es el mismo color a un 12 % de saturación, para las
     fichas que eligen dibujo oscuro sobre fondo claro. */
  const FONDOS = {
    carbon:  { claro: '#0F1014', oscuro: '#D9DAE2' },   /* negro          */
    purpura: { claro: '#7C3AED', oscuro: '#E4D6FD' },   /* púrpura, marca */
    lila:    { claro: '#0B7B78', oscuro: '#CCE8E7' },   /* turquesa       */
    oro:     { claro: '#8A6D10', oscuro: '#F1E5BC' },   /* oro            */
    verde:   { claro: '#12793F', oscuro: '#CBEAD8' },   /* verde          */
    rojo:    { claro: '#B21F27', oscuro: '#F7D2D4' },   /* rojo           */
    azul:    { claro: '#1D5FB0', oscuro: '#D6E3F6' },   /* azul           */
    ambar:   { claro: '#C4490B', oscuro: '#FADDCD' },   /* naranja        */
    rosa:    { claro: '#BE1C77', oscuro: '#FAD3E6' },   /* magenta        */
    gris:    { claro: '#5A5E6B', oscuro: '#E2E2EA' }    /* gris           */
  };
  /* Traduce la clave del color del dibujo a un color real. Acepta los dos
     valores antiguos para no romper las fichas ya guardadas. */
  function colorDibujo(clave) {
    if (!clave || clave === 'claro' || clave === 'blanco') return '#FFFFFF';
    if (clave === 'oscuro' || clave === 'negro') return '#0F1014';
    return (FONDOS[clave] && FONDOS[clave].oscuro) || '#FFFFFF';
  }
  const NOMBRE_FONDO = {
    carbon:'Carbón', purpura:'Púrpura', lila:'Lila', oro:'Oro', verde:'Verde',
    rojo:'Rojo', azul:'Azul', ambar:'Ámbar', rosa:'Rosa', gris:'Gris'
  };

  /* Los dibujos. El vocabulario es el de la tienda —lo que se colecciona
     y lo que se usa para mirarlo— más los guiños de franquicia que pidió
     Leonardo. Fuera quedaron la caja, la hoja, el ancla y el reloj: eran
     relleno, y un avatar que nadie elige ocupa sitio al que sí.

     Todos son siluetas propias sobre una rejilla de 24: NO se copia arte
     de nadie. Una pokébola es un círculo con una banda, y eso es
     geometría; reproducir el dibujo oficial de Pikachu sería otra cosa y
     no se hace en una tienda que vende producto de esas marcas. */
  const AVATARES = {
    /* — la casa — */
    carta:    '<path d="M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M9 7h6M9 11h6M9 15h3"/>',
    slab:     '<rect x="4" y="2" width="16" height="20" rx="2"/><rect x="7" y="7" width="10" height="11" rx="1"/><path d="M8 4.5h8"/>',
    sobre:    '<path d="M7 6.5h10V20a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V6.5z"/><path d="M7 6.5l1.7-2.5 1.65 2.5L12 4l1.65 2.5L15.3 4 17 6.5"/><path d="M9.5 11h5"/>',
    lupa:     '<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21"/>',
    guante:   '<path d="M8 11V5.5a1.5 1.5 0 0 1 3 0V11m0 0V4.5a1.5 1.5 0 0 1 3 0V11m0 0V6.5a1.5 1.5 0 0 1 3 0V14a7 7 0 0 1-7 7 7 7 0 0 1-7-7v-2.5a1.5 1.5 0 0 1 3 0V13"/>',
    trofeo:   '<path d="M7 4h10v5a5 5 0 0 1-10 0V4z"/><path d="M7 6H4v1a3 3 0 0 0 3 3M17 6h3v1a3 3 0 0 1-3 3M9 20h6M12 14v6"/>',
    corona:   '<path d="M3 8l4 3.4L12 4l5 7.4L21 8l-1.5 9.8a1 1 0 0 1-1 .85H5.5a1 1 0 0 1-1-.85L3 8z"/><circle cx="3" cy="6.3" r="1.7"/><circle cx="12" cy="2.5" r="1.8"/><circle cx="21" cy="6.3" r="1.7"/>',
    gema:     '<path d="M6 3h12l3 6-9 12L3 9l3-6z"/><path d="M3 9h18M9 3l3 18M15 3l-3 18"/>',
    estrella: '<path d="M12 3l2.6 5.8 6.4.7-4.8 4.3 1.3 6.2L12 17l-5.5 3 1.3-6.2L3 9.5l6.4-.7L12 3z"/>',

    /* — guiños de Pokémon, en silueta — */
    pokebola: '<circle cx="12" cy="12" r="9.2"/><path d="M2.8 12h5.6M15.6 12h5.6"/><circle cx="12" cy="12" r="3.4"/>',
    umbreon:  '<path d="M6.6 20.5c-1.5-1.9-2.2-3.9-2.2-6 0-2.2 1-4.1 2.7-5.4L5.4 3.3a.5.5 0 0 1 .75-.53l4.3 2.6a6.6 6.6 0 0 1 3.1 0l4.3-2.6a.5.5 0 0 1 .75.53l-1.7 5.8c1.7 1.3 2.7 3.2 2.7 5.4 0 2.1-.7 4.1-2.2 6z"/><circle cx="9.3" cy="13.6" r="1.15" fill="none" stroke-width="1.6"/><circle cx="14.7" cy="13.6" r="1.15" fill="none" stroke-width="1.6"/>',
    colita:   '<path d="M20.4 3.2l-7.6 4.9 3.2.5-6.1 4.6 2.9.7-8.6 6.9 1.6-6.1-2.8.6 4.4-5.6-2.7-.2z"/>',
    gengar:   '<path d="M5.1 2.9l3.6 3.9a9.3 9.3 0 0 1 6.6 0l3.6-3.9a.45.45 0 0 1 .78.36l-.62 5.2A8 8 0 0 1 20.6 13c0 4.3-3.85 7.5-8.6 7.5S3.4 17.3 3.4 13c0-1.7.6-3.3 1.54-4.54l-.62-5.2a.45.45 0 0 1 .78-.36z"/><path d="M8.2 10.1l2.2 3.2H6.6zM15.8 10.1l-2.2 3.2h3.8zM7.6 15.2h8.8l-1.45 2.2h-1.5L12 16.1l-1.45 1.3h-1.5z" fill="#fff" fill-opacity=".95"/>',

    /* — otras franquicias, también en silueta — */
    ojoMilenario: '<path d="M2.4 12s3.9-5.6 9.6-5.6S21.6 12 21.6 12s-3.9 5.6-9.6 5.6S2.4 12 2.4 12z"/><circle cx="12" cy="12" r="2.7"/><path d="M6.4 17.2l-1.1 4M12 17.8V22M17.6 17.2l1.1 4M5 8.6h14"/>',
    calavera: '<path d="M12 2.6c4.6 0 7.8 3.2 7.8 7.5 0 2.5-1.1 4.3-2.6 5.3v2.2a1.4 1.4 0 0 1-1.4 1.4H8.2a1.4 1.4 0 0 1-1.4-1.4v-2.2C5.3 14.4 4.2 12.6 4.2 10.1 4.2 5.8 7.4 2.6 12 2.6z"/><circle cx="9.2" cy="10.2" r="1.7"/><circle cx="14.8" cy="10.2" r="1.7"/><path d="M6.5 21h11"/>',
    esfera:   '<circle cx="12" cy="12" r="9"/><path d="M12 7.4l1.15 2.35 2.6.38-1.88 1.83.44 2.58L12 13.31l-2.31 1.21.44-2.58L8.25 10.1l2.6-.38z"/>',
    mana:     '<path d="M12 2.4c2.8 3.4 7.2 6 7.2 10.6A7.2 7.2 0 0 1 12 21.6a7.2 7.2 0 0 1-7.2-8.6C4.8 8.4 9.2 5.8 12 2.4z"/>',
    mando:    '<path d="M8.4 7.2h7.2c3.2 0 5.8 2.7 5.8 6.1 0 1.9-.5 4.3-2.7 4.3-1.7 0-2.5-1.5-3.7-2.3-.6-.4-1.3-.6-2-.6h-1.6c-.7 0-1.4.2-2 .6-1.2.8-2 2.3-3.7 2.3-2.2 0-2.7-2.4-2.7-4.3 0-3.4 2.6-6.1 5.8-6.1z"/><path d="M7.4 10.8v2.8M6 12.2h2.8"/><circle cx="16" cy="11.4" r=".9"/><circle cx="17.9" cy="13.5" r=".9"/>',

    /* — filo — */
    espada:   '<path d="M12 1.5l1.8 3.3v8.6h-3.6V4.8zM7.6 14.6h8.8v1.9H7.6zM11.1 16.9h1.8v3.1h1.9v1.9H9.2v-1.9h1.9z"/>',
    espadas:  '<path d="M4 3l7.6 7.6M20 3l-7.6 7.6M12 11.2l2.2 2.2M12 11.2L9.8 13.4"/><path d="M14.2 13.4l5.4 5.4-1.6 1.6-5.4-5.4M9.8 13.4l-5.4 5.4 1.6 1.6 5.4-5.4"/>',
    hacha:    '<path d="M5.4 2.4c2.3 4.7 3.1 11.7 2.4 19.9-2.9-6.1-3.7-13.4-2.4-19.9z"/><path d="M11.4 1.5c2.5 5 3.3 12.5 2.6 21.4-3.1-6.5-3.9-14.4-2.6-21.4z"/><path d="M17.4 2.4c2.3 4.7 3.1 11.7 2.4 19.9-2.9-6.1-3.7-13.4-2.4-19.9z"/>',
    escudo:   '<path d="M12 2.8l8 3v6.2c0 4.4-3.3 7.9-8 9.2-4.7-1.3-8-4.8-8-9.2V5.8l8-3z"/><path d="M12 7.4v8M8.6 11h6.8"/>',

    /* — juego — */
    dado:     '<rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.3"/><circle cx="15.5" cy="15.5" r="1.3"/><circle cx="12" cy="12" r="1.3"/>',
    diana:    '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.6"/>',
    rayo:     '<path d="M13 2L5 13h5l-1 9 8-11h-5l1-9z"/>',
    llama:    '<path d="M12 2s5 4.5 5 9a5 5 0 0 1-10 0c0-1.6.7-3 1.5-4 0 2 1 3 2 3 .8 0 1.5-.7 1.5-2 0-2-1.5-4 0-6z"/>',
    rombo:    '<path d="M12 2l10 10-10 10L2 12 12 2z"/><path d="M12 7l5 5-5 5-5-5 5-5z"/>',
    luna:     '<path d="M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5z"/>',
    ojo:      '<path d="M2 12s3.8-6 10-6 10 6 10 6-3.8 6-10 6-10-6-10-6z"/><circle cx="12" cy="12" r="2.6"/>',
    llave:    '<circle cx="8" cy="8" r="4.2"/><path d="M11 11l9 9M17 17l2.5-2.5M14 14l2.5-2.5"/>',
    corazon:  '<path d="M12 20.6l-1.5-1.35C5.4 14.7 2.4 12 2.4 8.6A5.2 5.2 0 0 1 7.6 3.4c1.8 0 3.5.85 4.4 2.2.9-1.35 2.6-2.2 4.4-2.2a5.2 5.2 0 0 1 5.2 5.2c0 3.4-3 6.1-8.1 10.65z"/>',
    rayoDoble:'<path d="M11 2L4 12h4l-1 10 8-11h-4l1-9z"/><path d="M17 3l-2 4h2l-1 4"/>',
    anillo:   '<circle cx="12" cy="14" r="6.4"/><path d="M8.4 8.4L9.8 3h4.4l1.4 5.4"/>',
    montana:  '<path d="M2.6 19.4L9 7.6l3.6 6.2 2.2-3.4 6.6 9z"/><circle cx="7.6" cy="5.4" r="1.8"/>',
    /* LA ESTRELLA DE CUATRO PUNTAS de la casa, sin el marco: con el marco
       cuadrado sería el isotipo, y el manual prohíbe recrear el logo.
       Sola es una forma genérica y se puede usar. */
    chispa:   '<path d="M12 1.4c.75 5.35 3.5 8.1 8.85 8.85-5.35.75-8.1 3.5-8.85 8.85-.75-5.35-3.5-8.1-8.85-8.85C8.5 9.5 11.25 6.75 12 1.4z"/><path d="M18.9 15.6c.3 2.1 1.4 3.2 3.5 3.5-2.1.3-3.2 1.4-3.5 3.5-.3-2.1-1.4-3.2-3.5-3.5 2.1-.3 3.2-1.4 3.5-3.5z"/>',
    dragon:   '<path d="M3.2 8.1c0-2.4 2-4.3 4.4-4.3h4.9c1 0 1.9.3 2.6.9l1.5-2.1a.5.5 0 0 1 .9.28V6.6l3.1 1.5a.6.6 0 0 1 .05 1.05L17.4 11v2.1c0 3.9-3.2 7-7.1 7H7.4a.6.6 0 0 1-.5-.95l1.9-2.6H7.6c-2.4 0-4.4-2-4.4-4.4zm3.9.55a1.35 1.35 0 1 0 0 2.7 1.35 1.35 0 0 0 0-2.7z"/>'
  };
  const NOMBRE_AV = {
    carta:'Carta', slab:'Slab', sobre:'Sobre', lupa:'Lupa', guante:'Guante',
    trofeo:'Trofeo', corona:'Corona', gema:'Gema', estrella:'Estrella',
    pokebola:'Pokébola', umbreon:'Umbreon', colita:'Cola de rayo', gengar:'Fantasma',
    ojoMilenario:'Ojo milenario', calavera:'Calavera pirata', esfera:'Esfera',
    mana:'Maná', mando:'Mando', espada:'Espada', espadas:'Espadas cruzadas',
    hacha:'Garra', escudo:'Escudo', dado:'Dado', diana:'Diana', rayo:'Rayo',
    llama:'Llama', rombo:'Rombo', luna:'Luna', ojo:'Ojo', llave:'Llave',
    corazon:'Corazón', rayoDoble:'Tormenta', anillo:'Anillo', montana:'Montaña',
    chispa:'Estrella Myntic', dragon:'Dragón'
  };
  /* `stroke` y no `fill` en los que son contorno; los macizos llevan su
     propio relleno. Se distingue por la lista de abajo para no tener que
     escribir dos veces cada dibujo. */
  const AV_MACIZO = new Set(['estrella', 'corona', 'rayo', 'llama', 'rayoDoble', 'luna',
                             'colita', 'mana', 'corazon', 'espada', 'hacha', 'montana',
                             'chispa', 'dragon', 'gengar']);

  function svgAvatar(clave) {
    if (!AVATARES[clave]) return null;
    const macizo = AV_MACIZO.has(clave);
    return '<svg viewBox="0 0 24 24" aria-hidden="true" ' +
      (macizo
        ? 'fill="currentColor" stroke="none"'
        : 'fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"') +
      '>' + AVATARES[clave] + '</svg>';
  }

  /* Pinta el avatar de un jugador dentro del círculo que ya existía: si
     eligió uno, el dibujo; si no, su inicial, como hasta ahora. Así la
     tabla no cambia de aspecto para quien no ha elegido nada. */
  function ponerAvatar(el, fila) {
    const svg = fila && fila.avatar ? svgAvatar(fila.avatar) : null;
    if (svg) { el.classList.add('ico'); el.innerHTML = svg; }
    else { el.classList.remove('ico'); el.textContent = inicial(fila && fila.alias); }
    /* EL COLOR VA EN LÍNEA, no por clase. Son diez fondos por dos tonos:
       veinte reglas de CSS para algo que el servidor ya da resuelto, y
       que además tendría que repetirse para el podio, la fila y el
       perfil. La lista es cerrada, así que no entra nada que no sea uno
       de los tonos de la casa. */
    const f = fila && FONDOS[fila.fondo];
    if (f) {
      /* El círculo va siempre en el tono pleno del color elegido; el
         dibujo es el que se elige aparte. «claro» y «oscuro» siguen
         valiendo para las fichas guardadas antes de que hubiera paleta. */
      el.style.background = f.claro;
      el.style.color = colorDibujo(fila.color);
    } else { el.style.background = ''; el.style.color = ''; }
  }

  /* PODIO. Los tres primeros salen como figuras, no como filas: en una
     lista de diez, el primero y el séptimo se leen igual, y el sentido
     de una tabla es que ser primero se vea. Los huecos se dibujan
     también —«libre»— porque un podio con sitios vacíos invita a
     ocuparlos; uno recortado a los que hay parece que no cabe nadie. */
  /* QUÉ TABLA SE ESTÁ MIRANDO. Hay una por reto —son dos habilidades
     distintas y con una sola el reto más generoso en puntos se comía la
     otra— y esto recuerda cuál eligió el jugador. Arranca en personajes,
     que es el reto con el que casi todos empiezan. */
  let tablaModo = 'who';
  const NOMBRE_MODO = { who: 'Personajes', set: 'Expansiones', precio: 'Precios' };
  function filasTabla() {
    const t = S.datos && S.datos.tablas;
    return (t && t[tablaModo]) || [];
  }

  /* Los dos selectores —el de la portada y el de la pantalla de tabla—
     mueven la misma variable, así que cambiar de reto en uno se refleja
     en el otro. Uno solo sería peor: la portada enseña cinco filas y la
     pantalla completa el podio, y quien cambia en una espera encontrarlo
     igual en la otra. */
  /* ============================================================
     CUÁNTO QUEDA PARA QUE SE VACÍE LA TABLA

     El mes lo cuenta el servidor en hora de México, y el reloj tiene que
     contar lo mismo o diría una cosa distinta de la que manda. Se calcula
     el primer instante del mes siguiente EN MÉXICO y se compara con el
     reloj del navegador; el desfase por la hora del teléfono es de
     minutos y aquí no decide nada, solo informa.

     Se refresca cada segundo mientras se ve, y se para al salir: un
     intervalo vivo en una pantalla que nadie mira es batería regalada.
     ============================================================ */
  function finDeMesMX() {
    /* Hora de México en partes, sin depender de la zona del navegador. */
    const f = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Merida', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).formatToParts(new Date()).reduce((o, p) => (o[p.type] = p.value, o), {});
    const a = +f.year, m = +f.month;
    /* Milisegundos desde ahora hasta el día 1 del mes que viene a las
       00:00 de México, contados sobre la propia hora de México. */
    const ahora  = Date.UTC(a, m - 1, +f.day, +f.hour, +f.minute, +f.second);
    const cierre = Date.UTC(m === 12 ? a + 1 : a, m === 12 ? 0 : m, 1);
    return Math.max(0, cierre - ahora);
  }

  function textoCuenta(ms) {
    const s = Math.floor(ms / 1000);
    const d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600);
    const mi = Math.floor(s % 3600 / 60), se = s % 60;
    /* Con más de un día, los segundos son ruido: nadie mira un contador
       de 12 días esperando el tic. Por debajo sí, porque ya es una
       cuenta atrás de verdad. */
    if (d > 0) return d + (d === 1 ? ' día ' : ' días ') + h + ' h';
    return String(h).padStart(2, '0') + ':' + String(mi).padStart(2, '0') + ':' + String(se).padStart(2, '0');
  }

  let relojMes = 0;
  function pintarCuenta() {
    const ms = finDeMesMX();
    const t = textoCuenta(ms);
    ['ce-cuenta-v', 'ce-cuentam-v'].forEach(id => { const e = $(id); if (e) e.textContent = t; });
    /* El último día se marca, que es cuando la cifra decide algo. */
    const urge = ms < 864e5;
    ['ce-cuenta', 'ce-cuentam'].forEach(id => { const e = $(id); if (e) e.classList.toggle('urge', urge); });
  }
  function arrancarCuenta() {
    pintarCuenta();
    clearInterval(relojMes);
    relojMes = setInterval(pintarCuenta, 1000);
  }
  function pararCuenta() { clearInterval(relojMes); relojMes = 0; }

  function pintarSelectores() {
    document.querySelectorAll('[data-tmodo]').forEach(b => {
      const suyo = b.dataset.tmodo === tablaModo;
      b.setAttribute('aria-selected', suyo ? 'true' : 'false');
      b.classList.toggle('on', suyo);
    });
  }

  function cambiarTabla(modo) {
    if (modo === tablaModo) return;
    tablaModo = modo;
    pintarSelectores();
    if (!$('ce-board').hidden) { pintarPodio($('ce-podio')); pintarTabla($('ce-boardfull'), 10); pintarTuLugar(); }
    if (!$('ce-home').hidden)  pintarTabla($('ce-boardmini'), 5);
  }

  document.addEventListener('click', e => {
    const t = e.target.closest('[data-tono]');
    if (t) guardarFicha({ color: t.dataset.tono });
    const b = e.target.closest('[data-tmodo]');
    if (b) { A.toque(); cambiarTabla(b.dataset.tmodo); }
    /* En «¿Cuánto vale?» se contesta pulsando la carta. */
    const c = e.target.closest('#ce-par .carta');
    if (c && !c.disabled) responder(c.dataset.lado);
  });

  function pintarPodio(el) {
    const t = filasTabla();
    el.textContent = '';
    /* Orden visual 2 · 1 · 3, que es como se mira un podio. Y cada puesto
       es una TARJETA, no un círculo suelto: con el aro solo, el podio se
       leía como tres avatares flotando y no como un podio. La tarjeta le
       da superficie, el número lo sitúa y el rótulo lo nombra. */
    [2, 1, 3].forEach(pos => {
      const f = t.find(x => x.puesto === pos);
      const d = document.createElement('div');
      d.className = 'pod n' + pos + (f ? '' : ' vacio') + (f && f.yo ? ' yo' : '');

      const nu = document.createElement('span');
      nu.className = 'nu'; nu.textContent = '0' + pos;
      d.appendChild(nu);

      const av = document.createElement('span'); av.className = 'av';
      if (f) ponerAvatar(av, f); else av.textContent = '·';
      /* Los tres puestos llevan distintivo, no solo el primero: corona
         grande, corona pequeña y un galón mínimo. Con uno solo, el
         segundo y el tercero se diferenciaban únicamente por el metal del
         aro, y a tamaño de móvil eso no se distingue. */
      if (f && pos <= 3) {
        const c = document.createElement('span'); c.className = 'corona';
        c.setAttribute('aria-hidden', 'true');
        c.innerHTML = pos === 3 ? GALON : CORONA;
        av.appendChild(c);
      }
      d.appendChild(av);

      const nm = document.createElement('span'); nm.className = 'nm';
      nm.textContent = f ? (f.alias + (f.yo ? ' · tú' : '')) : 'Libre';
      d.appendChild(nm);

      const p = document.createElement('span'); p.className = 'pt';
      if (f) { p.textContent = num(f.puntos); d.appendChild(p); }

      const pl = document.createElement('span'); pl.className = 'pl'; pl.textContent = PL[pos];
      d.appendChild(pl);
      el.appendChild(d);
    });
  }

  /* TU LUGAR Y TU DISTANCIA. El servidor manda el puesto, la marca, a
     cuánto está quien va delante y qué puesto ocupa. Aquí solo se
     redacta, y se redacta con cuidado: se dice IGUALAR y no adelantar,
     porque con empate manda quién llegó antes y prometer lo contrario
     sería mentir sobre el propio juego. */
  function pintarTuLugar() {
    const d = S.datos || {};
    const p = (d.puestos || {})[tablaModo];
    const hay = p && p.puesto;
    tapar('ce-tuyo', !hay);
    tapar('ce-vermi', !hay);
    if (!hay) return;

    texto('ce-tuyo-p', '#' + p.puesto);
    texto('ce-tuyo-m', num(p.marca || 0));
    /* `NOMBRE_MODO` y no `NOMBRE_RETO`: son la misma lista, pero la
       segunda se declara más abajo en el archivo y usarla aquí sería
       tocar un `const` antes de su línea. Hoy funciona porque esto no
       corre durante la carga, pero es justo el patrón que ya tumbó la
       pantalla de resultado una vez. */
    const nom = NOMBRE_MODO[tablaModo] || '';
    if (p.puesto === 1) {
      texto('ce-tuyo-t', 'Vas primero en ' + nom.toLowerCase());
      texto('ce-tuyo-s', 'Nadie te ha alcanzado este mes. Falta poco para el cierre.');
    } else if (p.falta != null) {
      texto('ce-tuyo-t', 'Tu lugar este mes');
      texto('ce-tuyo-s', 'A ' + num(p.falta) + ' pts de igualar el puesto ' + p.puestoArriba + '.');
    } else {
      texto('ce-tuyo-t', 'Tu lugar este mes');
      texto('ce-tuyo-s', 'De ' + num(p.de) + (p.de === 1 ? ' jugador' : ' jugadores') + ' este mes.');
    }
  }

  /* «Ver mi lugar» lleva a tu fila o, si no estás entre los diez, a la
     tarjeta de arriba. Sin esto, quien va decimoquinto abre la tabla, no
     se encuentra y se va. */
  /* EL MES, ESCRITO. `%B` devuelve el mes en el idioma del locale del
     navegador y en un juego en español eso sale en inglés la mitad de las
     veces; el array es la misma solución que en el blog. La hora es la de
     México, que es la que usa el servidor para decidir de qué mes es cada
     partida — si no, el día 1 la tabla diría un mes y el servidor otro. */
  const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
                 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function pintarMes() {
    const f = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
    const m = MESES[f.getMonth()];
    texto('ce-mes', m.charAt(0).toUpperCase() + m.slice(1) + ' ' + f.getFullYear());
  }

  function verMiLugar() {
    const fila = document.querySelector('#ce-boardfull .row.yo');
    const dest = fila || $('ce-tuyo');
    if (!dest) return;
    dest.scrollIntoView({ block: 'center', behavior: 'smooth' });
    dest.classList.add('destello');
    setTimeout(() => dest.classList.remove('destello'), 1400);
  }

  function pintarTabla(el, limite) {
    const todas = filasTabla();
    /* En la tabla completa el podio ya enseña a los tres primeros, así
       que la lista arranca en el cuarto: repetirlos sería contar dos
       veces lo mismo. En el resumen de la portada no hay podio y se
       enseñan desde el primero. */
    const desde = limite > 5 ? 3 : 0;
    const filas = todas.slice(desde, limite);
    /* Sin filas no hay columnas que rotular: una cabecera de tabla sobre
       un hueco vacío parece que algo no cargó. */
    tapar('ce-colhd', !filas.length);
    el.textContent = '';
    if (!todas.length) {
      el.innerHTML = '<p class="empty">Nadie ha jugado a ' + NOMBRE_MODO[tablaModo].toLowerCase() +
        ' este mes.<br>La primera partida encabeza la tabla.</p>';
      return;
    }
    if (!filas.length) {
      el.innerHTML = '<p class="empty">Por ahora solo hay podio. El cuarto puesto está libre.</p>';
      return;
    }
    filas.forEach(f => {
      const d = document.createElement('div');
      d.className = 'row' + (f.yo ? ' yo' : '');
      const pos = document.createElement('span'); pos.className = 'p num'; pos.textContent = f.puesto;
      d.appendChild(pos);
      /* El avatar solo en la tabla completa: en el resumen de cinco
         filas de la portada no cabe sin apretar el nombre. */
      if (limite > 5) {
        d.classList.add('conav');   /* le abre la columna en la rejilla */
        const av = document.createElement('span'); av.className = 'rav';
        ponerAvatar(av, f); d.appendChild(av);
      }
      const nm = document.createElement('span'); nm.className = 'n';
      nm.textContent = f.alias + (f.yo ? ' · tú' : '');
      d.appendChild(nm);
      const p = document.createElement('span'); p.className = 'v num'; p.textContent = num(f.puntos);
      d.appendChild(p); el.appendChild(d);
    });
  }

  /* EL SELECTOR DE AVATAR.

     Botones de verdad con `role=radio`, no una rejilla de divs: se
     recorre con el tabulador y se elige con la barra, que es lo que
     espera quien no usa ratón. El cambio se guarda al momento —no hay
     botón de guardar— y si el servidor lo rechaza se deshace, porque
     dejar marcado algo que no se guardó es peor que no marcar nada. */
  function pintarAvatares() {
    const box = $('ce-avgrid');
    if (!box) return;
    box.textContent = '';
    Object.keys(AVATARES).forEach(clave => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'avop';
      b.dataset.av = clave;
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', NOMBRE_AV[clave] || clave);
      b.title = NOMBRE_AV[clave] || clave;
      b.innerHTML = svgAvatar(clave);
      const puesto = S.datos && S.datos.avatar === clave;
      b.setAttribute('aria-checked', puesto ? 'true' : 'false');
      b.classList.toggle('on', puesto);
      b.addEventListener('click', () => elegirAvatar(clave));
      box.appendChild(b);
    });
  }

  /* Los tres selectores del perfil —dibujo, color del círculo y tono—
     hacen lo mismo: pintar al momento, guardar y deshacer si falla. */
  function pintarColores() {
    const box = $('ce-colgrid');
    if (box) {
      box.textContent = '';
      Object.keys(FONDOS).forEach(clave => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'colop'; b.dataset.fondo = clave;
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-label', NOMBRE_FONDO[clave] || clave);
        b.title = NOMBRE_FONDO[clave] || clave;
        const oscuro = S.datos && S.datos.color === 'oscuro';
        b.style.background = oscuro ? FONDOS[clave].oscuro : FONDOS[clave].claro;
        const puesto = S.datos && S.datos.fondo === clave;
        b.setAttribute('aria-checked', puesto ? 'true' : 'false');
        b.classList.toggle('on', puesto);
        b.addEventListener('click', () => guardarFicha({ fondo: clave }));
        box.appendChild(b);
      });
    }
    /* La paleta del dibujo: blanco, negro y los diez tonos suaves de los
       mismos colores del círculo. Se pinta cada muestra sobre el color
       del círculo elegido, que es donde va a verse: una muestra sobre
       blanco engaña, porque el blanco sobre blanco no se distingue. */
    const tb = $('ce-tonosel');
    if (tb) {
      const fondo = (S.datos && FONDOS[S.datos.fondo] && FONDOS[S.datos.fondo].claro) || '#4A4D57';
      const actual = (S.datos && S.datos.color) || 'blanco';
      tb.textContent = '';
      ['blanco', 'negro'].concat(Object.keys(FONDOS)).forEach(clave => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'tonop'; b.dataset.tono = clave;
        b.setAttribute('role', 'radio');
        const nom = clave === 'blanco' ? 'Blanco' : clave === 'negro' ? 'Negro' : NOMBRE_FONDO[clave];
        b.setAttribute('aria-label', nom); b.title = nom;
        b.style.background = fondo;
        b.innerHTML = '<i style="background:' + colorDibujo(clave) + '"></i>';
        const puesto = actual === clave ||
          (clave === 'blanco' && actual === 'claro') || (clave === 'negro' && actual === 'oscuro');
        b.setAttribute('aria-checked', puesto ? 'true' : 'false');
        b.classList.toggle('on', puesto);
        tb.appendChild(b);
      });
    }
  }

  async function guardarFicha(cambio) {
    if (!S.datos) return;
    const antes = { avatar: S.datos.avatar, fondo: S.datos.fondo, color: S.datos.color };
    Object.assign(S.datos, cambio);
    pintarFicha();
    try {
      await api('/avatar', 'POST', cambio, { reintentos: 1 });
      A.toque();
      ['who', 'set', 'precio'].forEach(m => ((S.datos.tablas || {})[m] || [])
        .forEach(f => { if (f.yo) Object.assign(f, cambio); }));
      if (!$('ce-board').hidden) { pintarPodio($('ce-podio')); pintarTabla($('ce-boardfull'), 10); pintarTuLugar(); }
    } catch (e) {
      Object.assign(S.datos, antes);
      pintarFicha();
      toast('No se pudo guardar. Inténtalo otra vez.');
    }
  }

  /* Todo lo que se ve del perfil, de una vez: el avatar grande, los tres
     selectores y el nombre. */
  function pintarFicha() {
    pintarAvatares();
    pintarColores();
    const av = $('ce-pf-av');
    if (av && S.datos) ponerAvatar(av, { avatar: S.datos.avatar, alias: S.datos.alias,
                                         fondo: S.datos.fondo, color: S.datos.color });
    const al = $('ce-pf-alias');
    if (al && S.datos) al.textContent = S.datos.alias || 'Sin nombre';
    const bol = $('ce-pf-bol');
    if (bol && S.datos) bol.checked = !!S.datos.boletin;
  }

  /* El interruptor del perfil. Se aplica al instante y, si el guardado
     falla, se deshace: dejar la casilla marcada cuando no se guardó es
     decirle a alguien que está apuntado cuando no lo está, y eso en un
     consentimiento no es un detalle. */
  const casBoletin = $('ce-pf-bol');
  if (casBoletin) casBoletin.addEventListener('change', async () => {
    const quiere = casBoletin.checked;
    const eco = $('ce-pf-bol-e');
    casBoletin.disabled = true;
    if (eco) eco.textContent = 'Guardando…';
    try {
      const r = await api('/boletin', 'POST', { quiere }, { reintentos: 1 });
      if (S.datos) { S.datos.boletin = quiere; S.datos.boletinDecidido = true; }
      if (r && r.regalo) { A.canje(); toast('+' + num(r.regalo) + ' puntos por apuntarte'); }
      if (eco) eco.textContent = quiere ? 'Apuntado' : 'Ya no recibes correos';
    } catch (e) {
      casBoletin.checked = !quiere;
      if (eco) eco.textContent = '';
      toast('No se pudo guardar. Inténtalo otra vez.');
    } finally { casBoletin.disabled = false; }
  });

  /* Los dos botones del aviso de la portada. El «ahora no» también
     guarda la decisión: si no, el aviso volvería en cada visita y eso es
     exactamente lo que hace que alguien se vaya. */
  async function decidirBoletin(quiere) {
    tapar('ce-bolhome', true);
    try {
      const r = await api('/boletin', 'POST', { quiere }, { reintentos: 1 });
      if (S.datos) { S.datos.boletin = quiere; S.datos.boletinDecidido = true; }
      if (r && r.regalo) { A.canje(); toast('+' + num(r.regalo) + ' puntos por apuntarte'); }
      else if (quiere) toast('Listo, te avisamos.');
      if (S.datos) { S.datos = await api('/estado'); pintarHome(); }
    } catch (e) {
      tapar('ce-bolhome', false);
      toast('No se pudo guardar. Inténtalo otra vez.');
    }
  }
  const bolSi = $('ce-bolhome-si'), bolNo = $('ce-bolhome-no');
  if (bolSi) bolSi.addEventListener('click', () => decidirBoletin(true));
  if (bolNo) bolNo.addEventListener('click', () => decidirBoletin(false));

  const btnVerMi = $('ce-vermi');
  if (btnVerMi) btnVerMi.addEventListener('click', verMiLugar);

  function elegirAvatar(clave) {
    if (!S.datos || S.datos.avatar === clave) return;
    guardarFicha({ avatar: clave });
  }

  /* MIS POSICIONES. Solo las mías: quien no está entre los diez de la
     tabla no tiene forma de saber dónde va, y ese es justo el jugador
     que necesita un motivo para volver. No se enseña a nadie más. */
  const NOMBRE_RETO = { who: 'Personajes', set: 'Expansiones', precio: 'Precios' };
  function pintarPuestos() {
    const box = $('ce-puestos');
    if (!box) return;
    const p = (S.datos && S.datos.puestos) || {};
    box.textContent = '';
    ['who', 'set', 'precio'].forEach(m => {
      const d = p[m] || { puesto: null, de: 0, marca: 0 };
      const fila = document.createElement('div');
      fila.className = 'pu' + (d.puesto === 1 ? ' top' : '');
      const nm = document.createElement('span'); nm.className = 'nm';
      nm.textContent = NOMBRE_RETO[m]; fila.appendChild(nm);
      const v = document.createElement('span'); v.className = 'va';
      if (d.puesto) {
        v.innerHTML = '<b class="num">' + d.puesto + '.º</b><i>de ' + d.de + '</i>';
      } else {
        /* Sin partida este mes no hay puesto, y decir «0.º» sería
           mentir: se dice lo que hay que hacer para tenerlo. */
        v.innerHTML = '<i>Sin partida este mes</i>';
        fila.classList.add('vacio');
      }
      fila.appendChild(v);
      const mk = document.createElement('span'); mk.className = 'mk num';
      mk.textContent = d.marca ? num(d.marca) + ' pts' : '';
      fila.appendChild(mk);
      box.appendChild(fila);
    });
  }

  function pintarAnuncio(el) {
    const a = S.datos.anuncio;
    el.textContent = '';
    if (!a || !a.activo || !a.titulo) return;
    const box = document.createElement(a.url ? 'a' : 'div');
    box.className = 'ad';
    if (a.url) { box.href = a.url; box.rel = 'noopener sponsored'; }
    const lab = document.createElement('span'); lab.className = 'adlab';
    lab.textContent = a.propio ? 'Myntic' : 'Publicidad'; box.appendChild(lab);
    if (a.img) {
      const im = document.createElement('span'); im.className = 'im';
      const i = document.createElement('img'); i.src = a.img; i.alt = ''; i.loading = 'lazy';
      i.addEventListener('error', () => im.remove());
      im.appendChild(i); box.appendChild(im);
    }
    const tx = document.createElement('span'); tx.className = 'tx';
    const bd = document.createElement('span'); bd.className = 'bd';
    const b = document.createElement('b'); b.textContent = a.titulo; bd.appendChild(b);
    if (a.texto) { const sp = document.createElement('span'); sp.textContent = a.texto; bd.appendChild(sp); }
    tx.appendChild(bd);
    if (a.url) {
      const go = document.createElement('span'); go.className = 'go'; go.setAttribute('aria-hidden', 'true');
      go.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13M13 6l6 6-6 6"/></svg>';
      tx.appendChild(go);
    }
    box.appendChild(tx); el.appendChild(box);
  }

  /* ============================================================
     NOMBRE DE JUGADOR — obligatorio antes de la primera partida
     ============================================================ */

  /* Sugerencias: a mucha gente le cuesta más inventarse un nombre que
     jugar, y esa fricción se paga en abandono justo después de lo
     difícil, que era registrarse. Se combinan dos listas del mundo de
     la casa —no «Usuario123»— y se comprueba que el resultado no esté
     tomado antes de ofrecerlo. */
  const SUG_A = ['Slab','Grial','Holo','Mint','Gem','Prisma','Foil','Vintage','Rare','Proof'];
  const SUG_B = ['Hunter','Master','Sensei','Cazador','Coleccionista','Tasador','Ojo','Curador'];

  function sugerencias(n) {
    const tomados = new Set(['who','set'].flatMap(m => (S.datos.tablas || {})[m] || [])
      .map(t => String(t.alias).toLowerCase()));
    const out = [];
    let vueltas = 0;
    while (out.length < n && vueltas < 60) {
      vueltas++;
      const a = SUG_A[Math.floor(Math.random() * SUG_A.length)];
      const b = SUG_B[Math.floor(Math.random() * SUG_B.length)];
      const c = a + b;
      if (c.length <= 16 && !tomados.has(c.toLowerCase()) && !out.includes(c)) out.push(c);
    }
    return out;
  }

  function pintarSugerencias() {
    const box = $('ce-nom-sug');
    box.textContent = '';
    sugerencias(3).forEach(t => {
      const b = document.createElement('button');
      b.type = 'button'; b.textContent = t;
      b.addEventListener('click', () => {
        $('ce-nom-i').value = t;
        $('ce-nom-i').dispatchEvent(new Event('input'));
        $('ce-nom-i').focus();
      });
      box.appendChild(b);
    });
  }

  $('ce-nom-i').addEventListener('input', e => {
    const v = e.target.value;
    $('ce-nom-n').textContent = v.length + '/16';
    $('ce-nom-b').disabled = v.trim().length < 3;
    $('ce-nom-e').textContent = '';
    $('ce-nom-e').className = 'msg';
  });

  $('ce-nom-f').addEventListener('submit', async e => {
    e.preventDefault();
    const valor = $('ce-nom-i').value.trim();
    const aviso = $('ce-nom-e');
    const boton = $('ce-nom-b');
    aviso.className = 'msg';
    if (valor.length < 3) { aviso.className = 'msg no'; aviso.textContent = 'Al menos 3 caracteres.'; return; }
    boton.disabled = true; boton.textContent = 'Guardando…';
    try {
      const r = await api('/alias', 'POST', { alias: valor });
      /* EL BOLETÍN SE MANDA APARTE Y NO BLOQUEA EL JUEGO.
         Si esta llamada falla, la persona entra a jugar igual: haberla
         hecho esperar por una suscripción sería cobrarle a ella un
         problema nuestro. Y solo se manda cuando la casilla existe —en
         el cambio de nombre desde el perfil no está—. */
      const cas = $('ce-nom-bol');
      if (cas && !S.cambiandoNombre) {
        api('/boletin', 'POST', { quiere: cas.checked }, { reintentos: 1 })
          .then(r => { if (r && r.regalo) toast('+' + num(r.regalo) + ' puntos por apuntarte'); })
          .catch(() => {});
      }
      A.boot(); A.good(5);
      S.datos = await api('/estado');
      /* Si se venía del perfil se vuelve al perfil: mandar a la portada
         a quien solo quería cambiarse el nombre le hace rehacer el
         camino. */
      if (S.cambiandoNombre) { S.cambiandoNombre = false; navegar('perfil'); }
      else inicio();
    } catch (err) {
      aviso.className = 'msg no';
      aviso.textContent = (err.datos && err.datos.mensaje) || 'No se pudo guardar. Inténtalo otra vez.';
      /* Si está tomado, se ofrecen alternativas en el acto en lugar de
         dejar a la persona probando a ciegas. */
      if (err.datos && err.datos.error === 'tomado') pintarSugerencias();
    } finally {
      boton.disabled = $('ce-nom-i').value.trim().length < 3;
      boton.textContent = S.cambiandoNombre ? 'Guardar nombre' : 'Empezar a jugar';
    }
  });

  /* Y al volver a la pantalla de registro de verdad, la casilla reaparece. */
  function pedirNombre() {
    tapar('ce-nom-bol-caja', !!S.cambiandoNombre);
    pintarSugerencias();
    $('ce-nom-b').disabled = true;
    ver('ce-nombre');
    setTimeout(() => $('ce-nom-i').focus({ preventScroll: true }), 120);
  }

  /* Cambiar el nombre desde el perfil reutiliza la misma pantalla que lo
     pide la primera vez: mismas reglas, mismo veto de nombres y misma
     comprobación de que no esté tomado. Duplicar eso sería garantizar
     que un día divergen. */
  $('ce-pf-nombre') && $('ce-pf-nombre').addEventListener('click', () => {
    S.cambiandoNombre = true;
    $('ce-nav').hidden = true;
    pedirNombre();
    if (S.datos && S.datos.alias) $('ce-nom-i').value = S.datos.alias;
    $('ce-nom-b').textContent = 'Guardar nombre';
    $('ce-nom-b').disabled = !(S.datos && S.datos.alias && S.datos.alias.length >= 3);
    /* La casilla del boletín NO sale aquí: quien viene a cambiarse el
       nombre ya decidió eso, y volver a enseñarle una casilla marcada que
       además no se envía es pedirle que desconfíe. El interruptor de
       verdad está en su perfil, de donde acaba de venir. */
    tapar('ce-nom-bol-caja', true);
  });

  /* Descarga y decodifica una imagen fuera de pantalla para que al
     asignarla al `<img>` se pinte en el mismo fotograma. `decode()` es
     lo que da esa garantía; `load` solo dice que llegaron los bytes. */
  const enCache = new Map();
  /* LAS IMÁGENES DE UNA PREGUNTA PUEDEN SER DOS.

     En «¿Cuánto vale?» el duelo enseña dos cartas, y hasta ahora solo se
     precargaba la de la izquierda —`q.imagen`, que es la que manda—: la
     de la derecha empezaba a descargarse cuando ya se había pintado, así
     que durante un instante se veía la carta de la ronda anterior o un
     hueco en blanco, con el reloj corriendo. */
  function imagenesDe(q) {
    if (!q) return [];
    if (q.par) return [q.par.izq.imagen, q.par.der.imagen];
    return [q.imagen];
  }
  function precargarTodas(q) { return Promise.all(imagenesDe(q).map(precargar)); }

  function precargar(url) {
    if (!url || enCache.has(url)) return enCache.get(url);
    const img = new Image();
    img.src = url;
    const listo = (img.decode ? img.decode() : Promise.resolve())
      .catch(() => {});                 /* una imagen rota no bloquea la partida */
    enCache.set(url, listo);
    /* La caché no crece sin fin: una partida larga son decenas de
       piezas y no hace falta guardarlas todas. */
    if (enCache.size > 16) enCache.delete(enCache.keys().next().value);
    return listo;
  }

  /* ============================================================
     PARTIDA
     ============================================================ */
  async function empezar(modo) {
    A.boot();
    try {
      const r = await api('/empezar', 'POST', { modo });
      S.partida = r.partida;
      S.datos.intentos = r.intentos;
      pintarIntentos();
      /* «¿De quién es esta pieza?» era el lenguaje del catálogo, no el
         del juego: aquí no se compra nada, se reconoce a alguien. */
      $('ce-ask').textContent = modo === 'set' ? '¿De qué expansión es?'
        : modo === 'precio' ? '¿Cuál vale más?' : '¿Qué personaje es?';
      $('ce-ztag').hidden = (modo !== 'who');
      S.modo = modo;
      S.pts = 0; S.racha = 0; S.mejorRacha = 0; S.recordRoto = false; S.arranque = 0;
      /* Las imágenes se descargan mientras corre la cuenta atrás: en el
         duelo de precios son DOS, y con una sola la segunda carta llegaba
         tarde. */
      precargarTodas(r.pregunta);
      $('ce-rec').textContent = S.datos.mejorPartida > 0 ? 'Récord ' + num(S.datos.mejorPartida) : 'Sin récord aún';
      $('ce-rec').className = 'rec';
      M.intensidad(0);
      ver('ce-play');
      pantallaJuego(true);
      modoPartida(true);
      montarRacha(0);
      /* En la partida nueva vuelve a cero sin celebrar nada: la
         transición de bajada sobra cuando no se ha perdido, se empieza. */
      if (racha) racha.set(0, { animate: false, announce: false });
      pintarHud();
      /* Cuenta atrás antes de la primera pieza. Hace dos cosas: evita
         que el toque con que se arrancó la partida caiga sobre una
         opción —pasaba, y costaba el intento entero—, y da el latido
         previo. Doce segundos empiezan mejor si sabes cuándo empiezan. */
      S.arranque = performance.now() + (r.pausaMs || 1740);
      cuentaAtras(() => mostrarPregunta(r.pregunta));
    } catch (e) {
      if (e.datos && e.datos.error === 'sin_intentos') toast('Sin vidas. Se recupera una cada 2 horas.');
      else if (e.datos && e.datos.error === 'sin_piezas') toast('Todavía no hay piezas para este reto.');
      else toast('No se pudo empezar. Revisa tu conexión.');
    }
  }

  /* 3 · 2 · 1 · ¡YA! a un segundo por número no: son cuatro segundos de
     espera antes de cada partida y en la tercera ya molesta. 480 ms por
     paso es suficiente para leerlo y prepararse. */
  function cuentaAtras(listo) {
    const pasos = ['3', '2', '1'];
    let i = 0;
    const paso = () => {
      if ($('ce-play').hidden) return;      /* se salió mientras contaba */
      if (i < pasos.length) {
        A.tick(3 - i);
        momento({ et: 'Prepárate', big: pasos[i], tono: 'pu', cuenta: true, ms: 470 });
        i++;
        setTimeout(paso, 480);
        return;
      }
      A.vamos();
      momento({ tit: '¡Ya!', tono: 'pu', ms: 380 });
      setTimeout(listo, 300);
    };
    paso();
  }

  function mostrarPregunta(q) {
    S.pregunta = q;
    S.bloqueado = true;          /* lo abre `arrancar()`, al final */
    $('ce-shot').src = q.imagen;
    $('ce-shot').alt = S.modo === 'set'
      ? 'Carta por identificar, con el pie tapado'
      : 'Personaje por identificar';
    /* Si la precarga no llegó a tiempo —conexión lenta— se espera a que
       decodifique antes de soltar el reloj, con tope: más vale empezar
       medio segundo tarde que contar doce segundos sobre la pieza
       anterior. El tope existe porque una imagen que nunca carga no
       puede dejar la partida colgada. */
    const lista = Promise.race([
      precargarTodas(q),
      new Promise(r => setTimeout(r, 600))
    ]);
    /* «Pieza 7» en un reto donde se comparan precios no dice nada: lo que
       importa es en qué ronda vas, que es lo que cuenta la senda. */
    $('ce-qtag').textContent = (S.modo === 'precio' ? 'Ronda ' : 'Pieza ') + q.n;
    $('ce-stage').classList.remove('revelada');
    $('ce-stage').classList.toggle('esGrial', !!q.grial);
    $('ce-gtag').hidden = !q.grial;

    $('ce-flash').textContent = ''; $('ce-flash').className = 'flash';
    const at = $('ce-asktop'); if (at) at.className = 'asktop';

    const box = $('ce-opts'); box.textContent = '';
    /* Con par no se pintan opciones: lo que se pulsa es la carta. Dos
       botones «izq» y «der» no significan nada para quien juega. */
    const soloPar = S.modo === 'precio' && !!q.par;
    if (S.modo === 'precio') {
      const pregunta = soloPar ? '¿Cuál vale más?' : '¿Cuánto vale esta carta?';
      $('ce-ask').textContent = pregunta;
      texto('ce-asktop', pregunta);
    }
    /* En precios manda la de arriba y la de la columna se calla: tener
       las dos sería preguntar dos veces lo mismo. */
    tapar('ce-asktop', S.modo !== 'precio');
    (soloPar ? [] : q.opciones).forEach((txt, i) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'opt'; b.dataset.val = txt;
      b.innerHTML = '<span class="k">' + (i + 1) + '</span><span class="lb"></span><span class="mk"></span>';
      b.querySelector('.lb').textContent = txt;
      b.addEventListener('click', () => responder(txt));
      box.appendChild(b);
    });

    const img = $('ce-shot');
    S.salto = -1;
    if (S.modo === 'who') {
      /* UN GRIAL NO SE ABRE: SALTA.

         La pieza normal empieza a ×6 y se va abriendo con el tiempo. El
         Grial se queda a ×6 y enseña un trozo distinto cada segundo, así
         que en vez de esperar a que se vea hay que armarla con retazos.
         Los trozos y su orden los manda el servidor. */
      if (q.saltos && q.saltos.length) {
        img.style.transitionProperty = 'transform-origin';
        img.style.transitionDuration = '.18s';
        img.style.transitionTimingFunction = 'cubic-bezier(.22,.61,.36,1)';
        img.style.transformOrigin = q.saltos[0][0] + '% ' + q.saltos[0][1] + '%';
        S.salto = 0;
      } else {
        img.style.transitionProperty = 'none';
        img.style.transformOrigin = (q.fx == null ? 50 : q.fx) + '% ' + (q.fy == null ? 50 : q.fy) + '%';
      }
      img.style.transform = 'scale(' + q.zoomDesde + ')';
      S.zoomTo = 1 / (q.verFinal || .7);
    } else if (q.grial && q.saltos && q.saltos.length) {
      /* EL GRIAL DE EXPANSIONES SE MIRA POR UNA VENTANA.

         En el reto normal la carta se ve entera desde el primer segundo,
         así que un Grial que valiera el doble sin esconder nada sería el
         doble de puntos regalados. Aquí pasa lo que en el de personajes:
         no se abre, salta. Se ve un cuarto de carta y cada segundo la
         ventana se muda a otra zona, así que hay que reconocer el set por
         el marco, por el estilo del dibujo, por la rareza — armándolo con
         retazos en vez de leyéndolo de un vistazo.

         Sin banda del pie: con el zoom puesto, la banda ya no cae sobre
         el pie de la carta y solo taparía ilustración. Lo que impide ver
         el código es que la ventana nunca baja ahí, y de eso se encarga
         el servidor al calcular los saltos. */
      img.style.transitionProperty = 'transform-origin';
      img.style.transitionDuration = '.3s';
      img.style.transitionTimingFunction = 'cubic-bezier(.22,.61,.36,1)';
      img.style.transformOrigin = q.saltos[0][0] + '% ' + q.saltos[0][1] + '%';
      img.style.transform = 'scale(' + q.zoomDesde + ')';
      S.salto = 0;
    } else {
      /* RETO DE EXPANSIONES. La carta se ve entera desde el primer
         segundo —no hay zoom que abrir— y lo que se tapa es el pie,
         donde va impreso el código del set. Sin eso no hay reto: la
         respuesta está escrita en la propia imagen. */
      img.style.transitionProperty = 'none';
      img.style.transform = 'none'; img.style.transformOrigin = '50% 50%';
    }
    /* «escarta» = lo que se enseña es una CARTA ENTERA y hay que verla
       completa: el cuadro toma su proporción y la imagen va con
       `contain`. Vale para el reto de expansiones y también para el
       Grial de precios, donde se pregunta cuánto vale la pieza: con el
       recorte de `cover` solo se veía el centro, y el dato que decide un
       precio —si es full art, la rareza, el marco— está en los bordes. */
    $('ce-stage').classList.toggle('escarta', S.modo === 'set');
    const grialDeCarta = S.modo === 'set' && !!(q.grial && q.saltos && q.saltos.length);
    $('ce-tapa').hidden = (S.modo !== 'set') || grialDeCarta;

    /* «¿CUÁNTO VALE?». Con par, se enseñan las dos cartas y el cuadro de
       siempre se aparta; sin par —el Grial, que pregunta el precio de una
       sola— vuelve el cuadro normal con la carta entera. */
    const esPrecio = S.modo === 'precio';
    const hayPar = esPrecio && !!q.par;
    /* EN «¿CUÁNTO VALE?» NO SE USA EL CUADRO CON ZOOM, NUNCA.

       El Grial enseñaba la carta dentro de `#ce-stage`, que es el cuadro
       de los otros dos retos: recorta con `cover`, arrastra el zoom y
       lleva la banda del pie. El resultado era que en la ronda que vale
       doble solo se veía un trozo, y eso mete una dificultad que este
       reto no pide — aquí hay que adivinar el PRECIO, no la carta.
       Leonardo lo dijo con esas palabras: «estás metiendo doble
       dificultad».
       Ahora el Grial usa la MISMA tarjeta que el duelo, con una sola
       carta: `contain`, sin transformación y con su nombre y expansión
       debajo. Así no puede heredar nada del cuadro, ni hoy ni cuando
       alguien toque el zoom del reto de personajes. */
    $('ce-par').hidden = !esPrecio;
    $('ce-par').classList.toggle('uno', esPrecio && !hayPar);
    $('ce-stage').hidden = esPrecio;
    document.body.classList.toggle('ce-precio', esPrecio);
    /* `ce-duo` marca que en pantalla hay DOS cartas y no el cuadro de
       siempre. Lo usa el reparto de altura en móvil: con el par, la
       columna no debe crecer —las cartas las limita el ancho y estirar
       solo repartía vacío—, pero en el Grial sí, porque ahí manda el
       cuadro y sin crecer se quedaba en cero de alto y la carta
       desaparecía. Se detectó mirándolo, no leyendo el código. */
    document.body.classList.toggle('ce-duo', hayPar);
    if (esPrecio) {
      /* Con par, una carta a cada lado; sin par —el Grial— la de la
         izquierda lleva la pieza y la derecha se esconde con `.uno`. */
      const izq = q.par ? q.par.izq
                        : Object.assign({ imagen: q.imagen }, q.cuanto || {});
      const der = q.par ? q.par.der : izq;
      $('ce-par-izq').src = izq.imagen;
      $('ce-par-der').src = der.imagen;
      /* LA CARTA SE PRESENTA, NO SE ADIVINA.

         El reto era comparar dos fotos sin nombre, y eso convierte en
         suerte lo que debería ser criterio: quien no reconoce la
         ilustración de memoria no tiene nada sobre lo que decidir.
         El nombre lleva además la variante entre paréntesis —«(Shiny
         Full Art)»—, que es la mitad del precio de una carta. */
      [['izq', izq], ['der', der]].forEach(([lado, c]) => {
        const ref = c.num ? c.colec + ' · ' + c.num : (c.colec || '');
        $('ce-nm-' + lado).textContent = c.carta || '';
        $('ce-sx-' + lado).textContent = ref;
        /* El texto alternativo con el nombre: quien navega con lector de
           pantalla no puede comparar dos fotos, pero sí dos cartas. */
        $('ce-par-' + lado).alt = (c.carta || 'Carta') + (ref ? ' · ' + ref : '');
      });
      document.querySelectorAll('#ce-par .carta').forEach(b => {
        /* En el Grial la carta no se pulsa: se contesta con los tres
           precios. Dejarla pulsable prometía una acción que no existe. */
        b.disabled = !hayPar; b.className = 'carta';
        b.querySelector('.pv').textContent = '';
        b.querySelector('.lb').textContent = 'Elegir esta';
        b.querySelector('.mk').textContent = '↗';
      });
    }
    $('ce-pie').hidden = !esPrecio;
    $('ce-senda').hidden = !esPrecio;
    if (esPrecio) pintarSenda(q);

    /* El reloj arranca DESPUÉS del aviso de Grial, no durante: cobrar
       el tiempo de un anuncio que nadie pidió es hacer trampa al revés.
       Mientras tanto la pregunta queda bloqueada.

       `S.arranque` es el instante en que el reloj del SERVIDOR empieza a
       contar esta pregunta; el de pantalla se cuelga de ahí para que los
       dos vayan sincronizados. En la primera pregunta de la partida no
       hay pausa previa y vale el momento actual. */
    const arrancar = () => {
      if (!S.bloqueado) return;        /* idempotente: puede llegar por dos vías */
      clearTimeout(S.salvavidas);
      S.bloqueado = false;
      const cero = S.arranque || performance.now();
      S.arranque = 0;
      /* Se guarda el arranque además del final: es lo que permite decirle
         al servidor cuánto se tardó DE VERDAD en pulsar, sin contar el
         viaje por la red. Ver el comentario de `responder`. */
      S.inicioLocal = cero;
      S.finLocal = cero + q.tiempoMs;
      reloj();
    };
    /* RED DE SEGURIDAD.

       `arrancar` cuelga de una promesa y de que la pantalla de juego siga
       visible. Si por lo que sea no llega a ejecutarse —un nodo que falta
       y revienta el render, un cambio de pantalla a destiempo—, la
       pregunta se queda pintada y muerta: el servidor cuenta el tiempo y
       aquí no se puede pulsar nada. Este temporizador la abre igual.
       Nunca debería entrar; existe para que el peor caso sea una pregunta
       que arranca tarde y no una partida perdida sin poder jugar. */
    clearTimeout(S.salvavidas);
    S.salvavidas = setTimeout(() => {
      if (S.pregunta === q && S.bloqueado && !S.enVuelo && !$('ce-play').hidden) {
        arrancar();
      }
    }, 2500);

    if (q.grial) {
      A.grial();
      momento({ ico: 'grial', et: 'Pieza especial', tit: 'Grial', sub: 'Esta vale el doble de puntos', tono: 'oro', anillo: true, ms: 1150 });
      /* Los 1.150 ms del aviso ya están descontados en el servidor, que
         es quien decide si la pieza es Grial. Aquí solo se espera. */
      setTimeout(() => { if (!$('ce-play').hidden) lista.then(arrancar); }, 1150);
    } else {
      lista.then(() => { if (!$('ce-play').hidden) arrancar(); });
    }
  }

  /* El reloj de pantalla es informativo. Al agotarse NO se declara la
     derrota aquí: se manda la respuesta vacía y decide el servidor, que
     es quien lleva el tiempo de verdad. */
  function reloj() {
    cancelAnimationFrame(S.raf);
    const q = S.pregunta;
    const paso = () => {
      const queda = Math.max(0, S.finLocal - performance.now());
      const frac = queda / q.tiempoMs;
      const f = $('ce-tfill');
      f.style.width = (frac * 100).toFixed(2) + '%';
      f.className = frac < .22 ? 'crit' : (frac < .5 ? 'warn' : '');
      /* El número además de la barra. Una barra a media asta no dice si
         quedan seis segundos o dos, y esa diferencia es la que decide
         entre arriesgar y esperar a que la imagen se abra más. */
      const sg = $('ce-segs');
      sg.textContent = (queda / 1000).toFixed(1) + 's';
      sg.className = 'segs num' + (frac < .22 ? ' crit' : '');
      if (q.saltos && q.saltos.length) {
        /* Un trozo por segundo y el zoom quieto, en los dos retos: lo que
           cambia entre ellos es cuánto se amplía, que lo decide el
           servidor y llega en `zoomDesde`. */
        const i = Math.min(q.saltos.length - 1,
                           Math.floor((q.tiempoMs - queda) / 1000));
        if (i !== S.salto) {
          S.salto = i;
          $('ce-shot').style.transformOrigin = q.saltos[i][0] + '% ' + q.saltos[i][1] + '%';
          A.salto();
        }
        $('ce-ztag').textContent = 'Trozo ' + (i + 1) + '/' + q.saltos.length;
      } else if (S.modo === 'who') {
        const z = S.zoomTo + (q.zoomDesde - S.zoomTo) * frac;
        $('ce-shot').style.transform = 'scale(' + z.toFixed(3) + ')';
        $('ce-ztag').textContent = '×' + z.toFixed(1);
      }
      const seg = Math.ceil(queda / 1000);
      if (seg !== S.ultimoTick && seg <= 5 && seg > 0) {
        S.ultimoTick = seg; A.tick(seg);
        if (seg <= 3) { const t = f.parentElement; t.classList.add('pulso'); setTimeout(() => t.classList.remove('pulso'), 280); }
      }
      if (queda <= 0) { responder(null); return; }
      S.raf = requestAnimationFrame(paso);
    };
    S.raf = requestAnimationFrame(paso);
  }
  function pararReloj() { cancelAnimationFrame(S.raf); S.raf = 0; S.ultimoTick = -1;
    clearTimeout(S.salvavidas); }

  /* LA BARRA DE SIETE PASOS.

     El último no es una barra sino un rombo de oro: el Grial ya tiene
     ese lenguaje en toda la casa y repetirlo aquí ahorra explicarlo.
     `grialCada` viene del servidor, así que la barra tiene tantos pasos
     como rondas haya de verdad entre un Grial y el siguiente.

     Ojo con el paso: `esGrial` en el servidor es `n % cada === 0`, luego
     la ronda 7 es el séptimo paso y no el primero del ciclo siguiente.
     De ahí el `((n - 1) % cada) + 1`. */
  function pintarSenda(q) {
    const cada = q.grialCada || 7;
    const paso = ((q.n - 1) % cada) + 1;
    const c = $('ce-senda-p');
    if (c.childElementCount !== cada) {
      c.textContent = '';
      for (let i = 0; i < cada; i++) c.appendChild(document.createElement('i'));
    }
    [...c.children].forEach((i, k) => {
      i.className = k + 1 < paso ? 'past' : k + 1 === paso ? 'now' : '';
    });
    $('ce-senda-n').textContent = paso + ' / ' + cada;
    $('ce-senda-et').textContent = q.grial ? 'Grial · puntos dobles' : 'Camino al Grial';
    $('ce-senda').classList.toggle('oro', !!q.grial);
  }

  /* Al contestar en «¿Cuánto vale?», los precios a la vista. Es la única
     forma de que la partida enseñe algo: saber que fallaste no vale de
     nada si no ves por cuánto. */
  function revelarPrecios(elegida, correcta, rev) {
    if (!rev) return;
    if (rev.tipo === 'par') {
      [['izq', rev.izqT], ['der', rev.derT]].forEach(([lado, txt]) => {
        const b = document.querySelector('#ce-par .carta[data-lado="' + lado + '"]');
        if (!b) return;
        b.disabled = true;
        $('ce-pv-' + lado).textContent = txt;
        /* EL RESULTADO NO SE DICE SOLO CON COLOR. El borde y el fondo
           marcan la carta, pero quien no distingue verde de rojo se queda
           sin saber cuál era: la línea de abajo lo dice con palabras. */
        b.querySelector('.lb').textContent =
          (lado === correcta ? '✓ Más cara' : 'Más barata');
        b.querySelector('.mk').textContent = '';
        b.classList.add(lado === correcta ? 'good' : 'bad');
        if (lado === elegida && lado !== correcta) b.classList.add('elegida');
      });
      /* POR CUÁNTO. Ver los dos precios no es lo mismo que saber la
         distancia, y la distancia es lo que se aprende: dos cartas que se
         parecen y se llevan cuatro mil pesos enseñan más que el acierto.
         Ocupa el sitio de la pregunta, que ya no hace falta. */
      if (rev.difT) {
        const t = (rev.caraT ? rev.caraT + ' vale ' : 'Van ') + rev.difT + ' más';
        $('ce-ask').textContent = t; texto('ce-asktop', t);
      }
      clase('ce-asktop', 'resuelta', true);
    } else if (rev.tipo === 'cuanto' && rev.texto) {
      $('ce-ask').textContent = 'Vale ' + rev.texto;
      texto('ce-asktop', 'Vale ' + rev.texto);
      clase('ce-asktop', 'resuelta', true);
    }
  }

  function revelar(elegida, correcta) {
    document.querySelectorAll('#ce-opts .opt').forEach(b => {
      b.disabled = true;
      if (b.dataset.val === correcta) {
        b.classList.add('good');
        b.querySelector('.mk').innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
      } else if (elegida && b.dataset.val === elegida) {
        b.classList.add('wrong');
        b.querySelector('.mk').innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>';
      } else b.classList.add('dim');
    });
    if (S.modo === 'who') {
      const img = $('ce-shot');
      img.style.transitionProperty = 'transform, transform-origin';
      img.style.transitionDuration = '.35s';
      img.style.transformOrigin = '50% 50%';
      img.style.transform = 'scale(1)';
    }
    /* La ficha pasa a enseñar la pieza ENTERA: durante la partida
       recorta para que el zoom llene el cuadro, pero al revelar hay que
       poder verla, y en un teléfono bajo el recuadro es casi 3:2. */
    /* Se deshace el zoom del Grial: al revelar hay que ver la carta
       entera, y el pie con ella — es la prueba de cuál era el set. */
    const img = $('ce-shot');
    if (S.modo === 'set' && img.style.transform && img.style.transform !== 'none') {
      img.style.transitionProperty = 'transform, transform-origin';
      img.style.transitionDuration = '.45s';
      img.style.transform = 'none';
      img.style.transformOrigin = '50% 50%';
    }
    $('ce-stage').classList.add('revelada');
  }

  async function responder(opcion) {
    /* EL DISPARO POR TIEMPO AGOTADO PASA AUNQUE ESTÉ BLOQUEADO.

       `bloqueado` significa dos cosas distintas: «la pregunta aún no ha
       arrancado» y «ya hay una respuesta viajando». Para la segunda hay
       que parar; para la primera, no — y si por lo que sea el arranque no
       llegó a abrirse, el reloj se vaciaba, `responder(null)` salía por
       aquí sin hacer nada y la partida se quedaba muerta en pantalla con
       el jugador pulsando opciones que no responden. Es lo que reportó
       Leonardo: «no dejaba picarle a la respuesta, se consumió el tiempo
       y perdí». Con una petición en vuelo sí se descarta, que es lo que
       evita contar dos veces. */
    if (S.enVuelo) return;
    if (S.bloqueado && opcion !== null) return;
    clearTimeout(S.salvavidas);
    S.bloqueado = true;
    S.enVuelo = true;
    if (opcion !== null) A.toque();
    pararReloj();

    /* CUÁNTO SE TARDÓ DE VERDAD, medido aquí y no en el servidor.
       El reloj del servidor incluye el viaje por la red en las dos
       direcciones, y en una conexión mala eso convertía una respuesta
       enviada dentro de plazo en una derrota. El servidor sigue siendo
       la autoridad —este número solo puede descontar hasta su margen, y
       no da ni un punto de más: el bono por rapidez lo calcula él. */
    const dt = S.inicioLocal ? Math.max(0, Math.round(performance.now() - S.inicioLocal)) : undefined;

    /* LA OPCIÓN SE MARCA ANTES DE SALIR LA PETICIÓN.
       Antes no se marcaba nada hasta que contestaba el servidor, así que
       con la red lenta el jugador pulsaba y no veía absolutamente nada:
       creía que el botón no funcionaba y volvía a pulsar. */
    if (opcion !== null) {
      document.querySelectorAll('#ce-opts .opt').forEach(b => {
        b.disabled = true;
        if (b.dataset.val === opcion) b.classList.add('enviando');
      });
      document.querySelectorAll('#ce-par .carta').forEach(b => {
        b.disabled = true;
        if (b.dataset.lado === opcion) b.classList.add('enviando');
      });
    }
    /* Y si tarda de verdad, se dice. Medio segundo es el umbral por
       debajo del cual un aviso molesta más de lo que informa. */
    const aviso = setTimeout(() => $('ce-play').classList.add('esperando'), 500);

    let r;
    try {
      r = await api('/responder', 'POST', { partida: S.partida, opcion, n: S.pregunta && S.pregunta.n, dt },
                    { plazo: 7000, reintentos: 2 });
    } catch (e) {
      /* Una respuesta que no llega no da la partida por perdida: el
         servidor guarda el estado real y la respuesta es idempotente, así
         que se puede volver a pulsar sin miedo a contar dos veces. */
      clearTimeout(aviso); $('ce-play').classList.remove('esperando');
      toast('No se pudo enviar. Toca otra vez tu respuesta.');
      /* También las cartas: en «¿Cuánto vale?» se pulsan estas y no las
         opciones, así que rehabilitando solo `.opt` el reto se quedaba
         sin nada que tocar después de un fallo de red. */
      document.querySelectorAll('#ce-opts .opt, #ce-par .carta').forEach(b => {
        b.disabled = false; b.classList.remove('enviando');
      });
      S.bloqueado = false; S.enVuelo = false;
      reloj();                      /* el reloj sigue corriendo en el servidor */
      return;
    }
    clearTimeout(aviso); $('ce-play').classList.remove('esperando');
    S.enVuelo = false;
    document.querySelectorAll('#ce-opts .opt, #ce-par .carta')
      .forEach(b => b.classList.remove('enviando'));
    revelar(opcion, r.correcta);
    revelarPrecios(opcion, r.correcta, r.revelar);

    if (!r.acierto) {
      A.bad();
      const st = $('ce-stage'); st.classList.add('fallo'); setTimeout(() => st.classList.remove('fallo'), 500);
      /* En el reto de precios la respuesta correcta es «izq» o «der», que
         no dice nada: se enseña el precio, que es lo que se aprende. */
      let queEra = '“' + r.correcta + '”';
      if (r.revelar && r.revelar.tipo === 'par') {
        queEra = 'la de la ' + (r.correcta === 'izq' ? 'izquierda' : 'derecha') +
                 ', ' + (r.correcta === 'izq' ? r.revelar.izqT : r.revelar.derT);
      } else if (r.revelar && r.revelar.tipo === 'cuanto') {
        queEra = r.revelar.texto;
      }
      $('ce-flash').textContent = (r.motivo === 'tiempo' ? 'Se acabó el tiempo. Era ' : 'Era ') + queEra;
      $('ce-flash').className = 'flash no';
      /* EL TIEMPO PARA LEER LA RESPUESTA LO MANDA EL JUGADOR.

         Eran cinco segundos fijos, y en «¿Cuánto vale?» se quedan cortos:
         ahí no hay una palabra que leer sino dos precios, dos nombres y
         una frase con la diferencia. Leonardo lo midió en «como un
         segundo» — no lo era, pero la sensación es la que cuenta cuando
         la pantalla cambia sola mientras estás leyendo.
         Ahora son ocho segundos en precios y seis en los demás, y
         **cualquier toque los adelanta**: quien ya leyó no espera, y
         quien está leyendo no se queda sin. Un temporizador que no se
         puede cortar siempre le sobra a uno y le falta a otro. */
      const espera = S.modo === 'precio' ? 8000 : 6000;
      let cerrado = false;
      const cerrar = () => {
        if (cerrado) return;
        cerrado = true;
        clearTimeout(reloj);
        document.removeEventListener('pointerdown', cerrar);
        $('ce-play').classList.remove('leyendo');
        terminar(r.resumen);
      };
      const reloj = setTimeout(cerrar, espera);
      /* Medio segundo de gracia: el dedo que acaba de pulsar la carta
         sigue en la pantalla y cerraría el revelado sin haberlo visto. */
      setTimeout(() => {
        if (!cerrado) {
          $('ce-play').classList.add('leyendo');
          document.addEventListener('pointerdown', cerrar);
        }
      }, 500);
      return;
    }

    S.pts = r.puntos; S.racha = r.racha; S.mejorRacha = Math.max(S.mejorRacha, r.racha);
    M.intensidad(r.racha);
    flotar('+' + r.gana, r.grial);
    A.good(r.racha);
    const st = $('ce-stage'); st.classList.add('acierto'); setTimeout(() => st.classList.remove('acierto'), 420);

    const bits = ['+' + r.gana];
    if (r.grial) bits.push('GRIAL ×2');
    if (r.mult > 1) bits.push('×' + r.mult.toFixed(2) + ' de racha');
    if (r.bonoZoom > 0) bits.push('+' + r.bonoZoom + ' por arriesgar');
    $('ce-flash').textContent = bits.join(' · ');
    $('ce-flash').className = 'flash ok';
    pintarHud();

    /* LA PAUSA Y EL MOMENTO LOS DECIDE EL SERVIDOR.

       Antes los decidía este archivo, y el servidor no sabía cuánto iba
       a durar: arrancaba el reloj de la pregunta siguiente en cuanto la
       servía, así que la pausa se la comía el jugador —hasta 1,9 s de
       sus 12, y con ellos parte del bono por rapidez—.
       Ahora `pausaMs` viene de arriba y `S.arranque` marca el instante
       exacto en que el reloj del servidor empieza a correr. El reloj de
       pantalla se cuelga de ahí, así que los dos van sincronizados
       aunque la imagen tarde en pintar. */
    const pausa = r.pausaMs || 1150;
    S.arranque = performance.now() + pausa;

    /* La imagen siguiente se descarga y se decodifica DURANTE la pausa.
       Sin esto, `img.src = otra` deja la anterior en pantalla hasta que
       el navegador decodifica la nueva, con el reloj ya corriendo: es el
       parpadeo que se veía al encadenar aciertos. */
    if (r.pregunta) precargarTodas(r.pregunta);

    if (r.momento === 'global') {
      /* El mejor resultado de toda la casa. Es la única cifra del juego
         que no depende de contra quién juegues, y por eso tiene pantalla
         propia: batir el récord de la casa es noticia, batir el tuyo es
         rutina a partir de la tercera partida. */
      S.recordRoto = true;
      $('ce-rec').textContent = 'Récord de la casa'; $('ce-rec').className = 'rec roto';
      setTimeout(() => {
        A.global();
        momento({ ico: 'corona', et: 'Récord de la casa', big: num(r.puntos),
                  sub: 'La mejor partida de todo Myntic', tono: 'oro', anillo: true, ms: pausa - 450 });
      }, 300);
    } else if (r.momento === 'record') {
      S.recordRoto = true;
      $('ce-rec').textContent = 'Récord batido'; $('ce-rec').className = 'rec roto';
      setTimeout(() => {
        A.record();
        momento({ ico: 'record', et: 'Nuevo récord', big: num(r.puntos), sub: 'Tu mejor partida hasta hoy', tono: 'oro', anillo: true, ms: pausa - 450 });
      }, 300);
    } else if (r.momento === 'hito') {
      setTimeout(() => {
        A.hito();
        momento({ ico: 'racha', et: 'Racha', big: String(r.hito), sub: 'seguidas sin fallar', tono: 'oro', anillo: true, ms: pausa - 450 });
      }, 300);
    } else if (r.momento === 'mult') {
      setTimeout(() => {
        A.mult();
        momento({ et: 'Multiplicador', big: '×' + r.mult.toFixed(2), sub: 'Cada acierto vale más', tono: 'pu', anillo: true, ms: pausa - 450 });
      }, 280);
    }
    const espera = pausa;

    if (r.fin) { setTimeout(() => terminar(null), espera); return; }
    setTimeout(() => { if (!$('ce-play').hidden) mostrarPregunta(r.pregunta); }, espera);
  }

  /* LA RACHA LA DIBUJA SU PROPIO COMPONENTE.

     `myntic-racha-streak.js` se encarga del número y del efecto: siete
     niveles, transición entre ellos, movimiento reducido, texto
     accesible y el ancho de la celda congelado para que pasar de 99 a
     100 no desplace Puntos ni Multiplicador.

     Aquí solo se le pasa el entero que ya validó el servidor. Se monta
     al entrar en partida porque necesita medir la celda, y una celda
     oculta no se puede medir. */
  let racha = null;

  function montarRacha(valor) {
    if (racha || typeof window.mountMynticRacha !== 'function') return;
    const listo = () => {
      try { racha = window.mountMynticRacha(valor || 0); }
      catch (e) { racha = null; }   /* sin componente, el número sigue saliendo */
    };
    /* Con la fuente a medias la medida de la celda sale mal, y esa
       medida es la que fija el ancho para el resto de la partida. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(listo);
    else listo();
  }

  function pintarHud() {
    $('ce-hpts').textContent = num(S.pts);
    const m = Math.min(1 + Math.floor(S.racha / 3) * .25, 3);
    $('ce-hmult').textContent = '×' + m.toFixed(2);

    if (racha) racha.set(S.racha);
    else $('ce-hstreak').textContent = S.racha;
  }

  async function terminar(resumen) {
    pararReloj();
    /* La tabla se pone en el reto que se acaba de jugar: quien termina
       una partida de expansiones quiere ver esa tabla, no la otra. */
    if (S.modo === 'who' || S.modo === 'set') { tablaModo = S.modo; pintarSelectores(); }
    modoPartida(false);
    if (!resumen) { try { S.datos = await api('/estado'); } catch (e) { } }
    const res = resumen || { puntos: S.pts, aciertos: 0, mejorRacha: S.mejorRacha, intentos: S.datos.intentos, record: false };
    S.recordRoto ? A.record() : A.end();
    $('ce-ovpts').textContent = num(res.puntos);
    $('ce-ovhits').textContent = res.aciertos;
    $('ce-ovbest').textContent = res.mejorRacha;
    $('ce-ovlives').textContent = res.intentos;

    /* EL RANGO SE GANA CON LA RACHA, DE VEINTE EN VEINTE.

       Antes la frase salía de los aciertos y con cuatro tramos sueltos.
       Ahora cada veinte de racha es un escalón con nombre, porque un
       rango que se nombra se persigue: «me falta poco para Conocedor»
       es un motivo para volver, «he hecho 43 aciertos» no lo es.

       El tono es el de la casa: frases cortas y sin exagerar. La
       confianza se comunica bajando el volumen, no subiéndolo. */
    const RANGOS = [
      { desde: 0,   titulo: 'Curioso' },
      { desde: 20,  titulo: 'Conocedor' },
      { desde: 40,  titulo: 'Coleccionista' },
      { desde: 60,  titulo: 'Maestro' },
      { desde: 80,  titulo: 'Autoridad' },
      /* El último escalón es el nombre del juego: llegar a cien no da un
         rango más, da el título entero. Es el mejor cierre posible para
         una escala y no había que inventar nada. */
      { desde: 100, titulo: 'Coleccionista Experto' }
    ];
    const mejor = res.mejorRacha || 0;
    let rango = RANGOS[0];
    for (const r of RANGOS) if (mejor >= r.desde) rango = r;

    /* EL RÓTULO VA AQUÍ Y NO ARRIBA, y no es un detalle de orden.

       Estaba once líneas más arriba, antes de declarar `rango`. Con
       `let` eso no es `undefined`: es un ReferenceError que abortaba
       `terminar()` entera, así que la pantalla de resultado —la del
       rango, las recompensas y «otra partida»— no llegaba a mostrarse
       NUNCA y el jugador se quedaba mirando la partida muerta. Es el
       fallo que reportó Leonardo el 26 sep 2026.
       Si alguna vez hay que mover este bloque, `rango` tiene que seguir
       declarándose antes. */
    $('ce-ovtag').textContent = res.record ? 'Tu mejor partida' : rango.titulo;

    let t;
    if (rango.desde === 0) {
      /* El primer escalón es donde cae casi todo el mundo al empezar, y
         una sola frase para veinte valores distintos se nota repetida.
         Se parte en tres según lo lejos que se haya llegado. */
      if (mejor === 0)      t = 'Primera y fuera. Pasa siempre: a ×6 casi nadie acierta, deja que se abra un poco.';
      else if (mejor < 5)   t = mejor + ' seguidas. La racha empieza a multiplicar a partir de la tercera.';
      else if (mejor < 12)  t = mejor + ' seguidas. Ya reconoces sin pensarlo; ahora aguanta.';
      else                  t = mejor + ' seguidas. Con ' + (20 - mejor) + ' más eres Conocedor.';
    } else {
      const siguiente = RANGOS.find(r => r.desde > rango.desde);
      const cola = siguiente
        ? ' Con ' + (siguiente.desde - mejor) + ' más, ' + siguiente.titulo + '.'
        : ' No hay escalón por encima.';
      t = {
        20:  'Conocedor. Distingues lo que la mayoría mira por encima.',
        40:  'Coleccionista. Ya no aciertas por descarte.',
        60:  'Maestro. Reconoces una pieza por un trozo.',
        80:  'Autoridad. De estos hay muy pocos.',
        100: 'Coleccionista Experto. El nombre del juego es tuyo.'
      }[rango.desde] + cola;
    }
    if (res.record) t += ' Y con récord nuevo.';
    $('ce-ovtxt').textContent = t;
    /* El saldo y qué se puede hacer con él, a la vista y en el momento
       en que acaban de subir los puntos. */
    const prox = S.datos ? S.datos.premios.find(p => p.pts > S.datos.puntos) : null;
    const listo = S.datos ? S.datos.premios.filter(p => p.pts <= S.datos.puntos) : [];
    $('ce-saldo-n').textContent = num(S.datos ? S.datos.puntos : 0) + ' pts';
    $('ce-saldo-t').textContent = listo.length
      ? 'ya te alcanza para ' + listo[listo.length - 1].n
      : (prox ? 'te faltan ' + num(prox.pts - S.datos.puntos) + ' para ' + prox.n : 'acumulados');
    $('ce-again').disabled = res.intentos <= 0;
    $('ce-again').textContent = res.intentos > 0
      ? 'Otra partida'
      : (faltaTexto(res.proximaVidaEn) ? 'Otra vida en ' + faltaTexto(res.proximaVidaEn) : 'Sin vidas');
    if (res.proximaVidaEn != null) S.vidaEn = res.proximaVidaEn;
    try { S.datos = await api('/estado'); S.vidaEn = S.datos.proximaVidaEn; pintarIntentos(); notaVidas(); } catch (e) { }
    ver('ce-over');
  }

  /* ============================================================
     RECOMPENSAS
     ============================================================ */
  const CANDADO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>';

  function pintarPremios() {
    const d = S.datos;
    $('ce-pmpts').textContent = num(d.puntos);
    const prox = d.premios.find(p => p.pts > d.puntos);
    $('ce-pmbar').style.width = prox ? Math.min(100, (d.puntos / prox.pts) * 100).toFixed(1) + '%' : '100%';
    $('ce-pmtxt').innerHTML = prox
      ? 'Siguiente: <b>' + prox.n + '</b> con ' + num(prox.pts) + ' pts.'
      : 'Tienes puntos para <b>cualquier recompensa</b>.';

    const box = $('ce-prlist'); box.textContent = '';
    d.premios.forEach(pr => {
      const listo = d.puntos >= pr.pts;
      const el = document.createElement('div'); el.className = 'prem' + (listo ? ' libre' : '');

      /* La cifra como moneda: es el argumento. «$500» decide, «70.000
         puntos» hay que traducirlo mentalmente. */
      const mon = document.createElement('span'); mon.className = 'mon';
      mon.textContent = dinero(pr.valor); el.appendChild(mon);

      const tx = document.createElement('span'); tx.className = 'tx';
      const b = document.createElement('b'); b.textContent = num(pr.pts) + ' pts'; tx.appendChild(b);
      const c = document.createElement('span');
      c.textContent = 'En compras desde ' + dinero(pr.min); tx.appendChild(c);
      el.appendChild(tx);

      /* Candado en lo que todavía no alcanza. Un botón «Aún no»
         desactivado dice lo mismo pero parece un botón roto; un candado
         se entiende sin leer. */
      if (!listo) {
        const cd = document.createElement('span'); cd.className = 'cand';
        cd.setAttribute('aria-label', 'Todavía no alcanza'); cd.innerHTML = CANDADO;
        el.appendChild(cd);
        const mb = document.createElement('span'); mb.className = 'pbar';
        const mi = document.createElement('i');
        mi.style.width = Math.min(100, (d.puntos / pr.pts) * 100).toFixed(1) + '%';
        mb.appendChild(mi); el.appendChild(mb);
      }

      /* Bloqueado no lleva botón: un botón apagado parece un botón
         roto y encima hay que atenuarlo tanto que deja de leerse. Lo
         que falta se dice con una línea de texto y una barra. */
      if (listo) {
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'btn bp';
        btn.textContent = 'Canjear';
        btn.addEventListener('click', () => canjear(pr, btn));
        el.appendChild(btn);
      } else {
        const f = document.createElement('span'); f.className = 'falta';
        f.textContent = 'Te faltan ' + num(pr.pts - d.puntos) + ' pts';
        el.appendChild(f);
      }
      box.appendChild(el);
    });
    pintarCupones();
  }

  function pintarCupones() {
    const cups = S.datos.cupones || [];
    $('ce-cupwrap').hidden = cups.length === 0;
    const box = $('ce-cup'); box.textContent = '';
    cups.forEach(c => {
      const d = document.createElement('div'); d.className = 'cup';
      const tx = document.createElement('div'); tx.className = 'tx';
      const b = document.createElement('b');
      b.textContent = dinero(c.valor) + ' de saldo'; tx.appendChild(b);
      const de = document.createElement('span');
      de.textContent = 'Desde ' + dinero(c.minimo) + ' · ' + new Date(c.creado).toLocaleDateString('es-MX');
      tx.appendChild(de); d.appendChild(tx);
      const cod = document.createElement('code'); cod.textContent = c.codigo;
      cod.title = 'Pulsa para copiar'; cod.style.cursor = 'pointer';
      cod.addEventListener('click', () => {
        navigator.clipboard?.writeText(c.codigo).then(
          () => toast('Código copiado'),
          () => {
            const r = document.createRange(); r.selectNodeContents(cod);
            const sel = getSelection(); sel.removeAllRanges(); sel.addRange(r);
            toast('Cópialo con el teclado');
          }
        );
      });
      d.appendChild(cod); box.appendChild(d);
    });
  }

  async function canjear(pr, btn) {
    if (btn.dataset.armed !== '1') {
      btn.dataset.armed = '1'; btn.textContent = 'Confirmar';
      setTimeout(() => { if (btn.dataset.armed === '1') { btn.dataset.armed = '0'; btn.textContent = 'Canjear'; } }, 4000);
      return;
    }
    btn.disabled = true; btn.textContent = 'Emitiendo…';
    try {
      const r = await api('/canjear', 'POST', { premio: pr.id });
      A.canje();
      toast('Cupón ' + r.codigo + ' listo');
      S.datos = await api('/estado');
      pintarPremios(); pintarHome();
    } catch (e) {
      const cod = e.datos && e.datos.error;
      toast(cod === 'sin_puntos' ? 'No te alcanzan los puntos.'
        : cod === 'shopify' ? 'No se pudo emitir el cupón. Tus puntos siguen intactos.'
        : 'No se pudo canjear. Inténtalo en un momento.');
      btn.disabled = false; btn.dataset.armed = '0'; btn.textContent = 'Canjear';
    }
  }

  /* ============================================================
     ENTRADAS
     ============================================================ */
  document.querySelectorAll('#ce-modes .mode').forEach(b =>
    b.addEventListener('click', () => empezar(b.dataset.mode)));
  $('ce-again').addEventListener('click', () => { if (S.datos.intentos > 0) empezar(S.modo); });
  $('ce-home1').addEventListener('click', inicio);

  /* NAVEGACIÓN. Antes cada pantalla tenía su propio «← Volver» y para
     pasar de la tabla a las recompensas había que regresar a la portada
     en medio. Tres destinos fijos y siempre a la vista se recorren en un
     toque, y además dicen que existen: nadie encontraba las recompensas
     porque nada las anunciaba. */
  const IR = {
    home() { pintarHome(); ver('ce-home'); },
    board() { pintarSelectores(); arrancarCuenta(); pintarMes(); pintarPodio($('ce-podio')); pintarTabla($('ce-boardfull'), 10); pintarTuLugar(); pintarAnuncio($('ce-adfull')); ver('ce-board'); },
    perfil() { pararCuenta(); pintarFicha(); pintarPuestos(); ver('ce-perfil'); },
    premios() { pintarPremios(); ver('ce-premios'); }
  };
  function navegar(a) {
    if (!IR[a]) return;
    IR[a]();
    document.querySelectorAll('#ce-nav button').forEach(b => b.classList.toggle('on', b.dataset.ir === a));
    $('ce-nav').hidden = false;
  }
  document.querySelectorAll('#ce-nav button').forEach(b =>
    b.addEventListener('click', () => navegar(b.dataset.ir)));
  $('ce-goboard').addEventListener('click', () => navegar('board'));
  $('ce-saldo').addEventListener('click', () => navegar('premios'));
  /* Salir a mitad de partida NO devuelve el intento: ya se consumió al
     empezar. Si lo devolviera, bastaría con salir cada vez que la pieza
     no se reconoce para tener intentos infinitos — que es justo el
     agujero que había que cerrar. Se avisa antes de hacerlo. */
  const btnSalir = raiz.querySelector('.salir');
  const RETO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg><span>Tienda</span>';
  function desarmarSalir() {
    btnSalir.dataset.armed = '0';
    btnSalir.classList.remove('armado');
    btnSalir.innerHTML = RETO;
  }
  btnSalir.addEventListener('click', e => {
    if (!saliendo()) return;                 /* fuera de partida: es un enlace normal */
    e.preventDefault();
    if (btnSalir.dataset.armed !== '1') {
      btnSalir.dataset.armed = '1';
      btnSalir.classList.add('armado');
      btnSalir.innerHTML = '<span>¿Abandonar?</span>';
      setTimeout(() => { if (btnSalir.dataset.armed === '1') desarmarSalir(); }, 3500);
      return;
    }
    desarmarSalir();
    pararReloj();
    /* No se marca bloqueado aquí: `responder` lo hace, y marcarlo antes
       haría que se saliera por su propia guarda sin enviar nada. */
    responder(null);
  });

  /* EL PRIMER TOQUE DESPIERTA; NO SILENCIA.

     Aquí estaba el fallo que dejó a Leonardo sin sonido el 26 sep 2026,
     y era una trampa perfecta:

     El navegador no deja sonar nada hasta que se toca la página, así que
     quien entra al juego no oye música por mucho que venga encendida.
     Ve el botón, lo pulsa para encenderla — y lo que hacía el código era
     apagarla, porque para él ya estaba encendida. Peor: guardaba esa
     decisión, así que no volvía a sonar NUNCA, ni ese día ni al mes
     siguiente. Un solo toque bastaba, y el botón estaba a la vista desde
     el primer segundo.

     Ahora, si el audio todavía no sonaba y ya estaba pedido, el toque
     solo lo pone en marcha. Silenciar sigue siendo un toque, pero el
     segundo: el primero enciende algo que la persona aún no había oído,
     que es exactamente lo que esperaba que hiciera. */
  $('ce-snd').addEventListener('click', () => {
    const dormido = !audioSuena() || reciénDespierto();
    despertarAudio();
    if (dormido && A.on) { pintarAudio(); avisarSonido(); A.good(1); return; }
    A.on = !A.on;
    pref.efectos = A.on; guardarPref(pref);
    pintarAudio(); avisarSonido();
    if (A.on) A.good(1);
  });
  $('ce-mus').addEventListener('click', () => {
    const dormido = !audioSuena() || reciénDespierto();
    despertarAudio();
    if (dormido && M.quiere) { pintarAudio(); avisarSonido(); return; }
    M.on ? M.parar() : M.arrancar();
    pref.musica = M.quiere; guardarPref(pref);
    pintarAudio(); avisarSonido();
  });

  document.addEventListener('keydown', e => {
    if ($('ce-play').hidden || S.bloqueado) return;
    const i = ['1', '2', '3'].indexOf(e.key);
    if (i < 0) return;
    const b = document.querySelectorAll('#ce-opts .opt')[i];
    if (b) { e.preventDefault(); b.click(); }
  });

  /* Cambiar de pestaña congela la cuenta en pantalla. No da ventaja: el
     servidor sigue midiendo, así que volver tarde pierde igual. */
  let congelado = 0;
  document.addEventListener('visibilitychange', () => {
    if ($('ce-play').hidden || S.bloqueado) return;
    if (document.hidden) { congelado = Math.max(0, S.finLocal - performance.now()); pararReloj(); }
    else if (congelado > 0) { S.finLocal = performance.now() + congelado; congelado = 0; reloj(); }
  });

  /* En móvil la imagen y las tres respuestas no caben a la vez con el
     encabezado de la tienda encima: había que hacer scroll en mitad de
     una cuenta atrás de doce segundos, que es lo peor que puede pasarle
     a este juego. Durante la partida el juego ocupa la pantalla entera
     y el resto de la tienda se aparta; al salir, todo vuelve.
     Se usa `dvh` y no `vh` porque en móvil la barra del navegador
     aparece y desaparece, y con `vh` las opciones quedan bajo ella. */
  /* `ce-jugando` = el juego ocupa la pantalla (siempre, en esta página).
     `ce-partida`  = hay una pregunta en marcha y no se puede scrollear.
     Separarlos es lo que devuelve el scroll a la portada del juego sin
     perderlo durante la partida. */
  function pantallaJuego(activo) {
    document.documentElement.classList.toggle('ce-jugando', activo);
    document.body.classList.toggle('ce-jugando', activo);
  }
  function modoPartida(activo) {
    /* Durante la partida no se ve ninguna tabla: el reloj del mes se
       para y deja de consumir. */
    if (activo) pararCuenta();
    document.documentElement.classList.toggle('ce-partida', activo);
    document.body.classList.toggle('ce-partida', activo);
    /* Cada minijuego con su tonada, y no por adornar: el de personajes
       se juega con el pulso —zoom que se abre, hay que disparar— y le va
       el chiptune; el de expansiones se juega con el ojo, mirando una
       carta quieta, y ahí una pista que empuja estorba. Fuera de la
       partida, la de salón. */
    const suya = S.modo === 'set' ? 'mesa' : S.modo === 'precio' ? 'enigma' : 'chip';
    M.cambiar(activo ? suya : 'salon');
    /* Durante la partida no hay nada que navegar, y un toque accidental
       en la barra de abajo cuesta la racha entera. */
    $('ce-nav').hidden = activo;
  }
  /* Fuera de una partida, «salir» significa volver a la tienda; dentro,
     abandonar. El mismo botón con dos destinos según dónde estés, que
     es lo que la persona espera de un botón de salida. */
  function saliendo() { return !$('ce-play').hidden && S.partida && !S.bloqueado; }

  /* La página ENTERA del juego va a pantalla completa, no solo la
     partida. Antes se entraba a una página normal de la tienda, con su
     encabezado y su buscador, y el juego quedaba como un bloque más
     dentro; había que bajar para verlo y el cambio de contexto llegaba
     tarde. Ahora al entrar ya estás dentro, y el logo con el botón de
     salir son la única vía de vuelta — visible, pero una sola. */
  function inicio() {
    pararReloj(); modoPartida(false); pantallaJuego(true);
    /* Sin nombre no se entra: elegirlo es parte de entrar a un juego,
       no un ajuste que se pospone. Antes era opcional y casi nadie lo
       ponía, así que la tabla se llenaba de «Jugador 4821» y parecía
       que no jugaba nadie — que es lo contrario de lo que una tabla
       tiene que transmitir. */
    if (S.datos && !S.datos.alias) { $('ce-nav').hidden = true; pedirNombre(); return; }
    navegar('home');
  }

  /* Volver al juego después de iniciar sesión.

     `return_url` no sirve: se comprobó siguiendo la cadena de
     redirecciones y el destino SE PIERDE al saltar al OAuth de
     Shopify, que deja a la persona en account.mynticshop.com — otro
     dominio, otro diseño, y sin camino de vuelta. Pulsar el logo
     devuelve a la portada de la tienda, no al juego, y ahí se pierde.

     Como ese dominio no ejecuta este tema, la marca se deja ANTES de
     salir y se recoge al volver: en cuanto la persona pisa de nuevo
     mynticshop.com con sesión iniciada, el layout la trae aquí.
     Caduca a los 30 minutos para no secuestrar una visita de mañana. */
  /* El registro se abre en otra pestaña y ESTA se queda preguntando al
     servidor si ya hay sesión. Cuando la hay, entra sola.

     Es lo único que funciona de verdad: Shopify autentica en
     account.mynticshop.com —dominio suyo, donde no podemos poner nada—
     y al acabar deja a la persona allí, sin vuelta. Quien no adivina
     que hay que pulsar el logo se va pensando que el juego no existía
     y que solo queríamos su correo.

     Se consulta cada 2.5 s durante 10 minutos: suficiente para leer un
     correo con calma, y luego para, porque una pestaña preguntando
     eternamente gasta batería de alguien que ya se fue. */
  const enlaceLogin = $('ce-entrar');
  let vigilando = 0;

  function vigilarSesion() {
    clearInterval(vigilando);
    const hasta = Date.now() + 600000;
    vigilando = setInterval(async () => {
      if (Date.now() > hasta) { clearInterval(vigilando); return; }
      try {
        S.datos = await api('/estado');
        clearInterval(vigilando);
        A.boot(); A.good(4);
        inicio();
      } catch (e) { /* sigue sin sesión: se vuelve a preguntar */ }
    }, 2500);
  }

  if (enlaceLogin) {
    /* La marca la recoge `layout/theme.liquid` para devolver al juego en
       cuanto se pise cualquier página de la tienda con sesión. Es la red
       para el caso en que Shopify suelte a la persona en su cuenta en
       vez de en el `return_url`. */
    enlaceLogin.addEventListener('click', () => {
      try { localStorage.setItem('myntic-volver-juego', String(Date.now())); } catch (e) {}
    });
  }

  /* SI VUELVE SIN HABER TERMINADO.
     Con el acceso en esta misma pestaña, volver es el botón «atrás»: la
     página sale de la caché del navegador y hay que comprobar la sesión
     otra vez, porque puede haberla conseguido igualmente. Solo si sigue
     sin haberla se enseña el recordatorio. */
  window.addEventListener('pageshow', e => {
    if (!e.persisted || $('ce-login').hidden) return;
    api('/estado').then(d => { S.datos = d; inicio(); })
                  .catch(() => { $('ce-esperando').hidden = false; vigilarSesion(); });
  });
  /* Por si el aviso automático tarda o la pestaña se cerró antes. */
  const yaEsta = $('ce-yaesta');
  if (yaEsta) yaEsta.addEventListener('click', async () => {
    yaEsta.disabled = true; yaEsta.textContent = 'Comprobando…';
    try { S.datos = await api('/estado'); clearInterval(vigilando); inicio(); }
    catch (e) {
      yaEsta.disabled = false; yaEsta.textContent = 'Comprobar';
      toast('Todavía no hay sesión. Termina el acceso y vuelve a pulsar.');
    }
  });

  /* Si vuelve a esta pestaña tras registrarse, se comprueba al instante
     en vez de esperar al siguiente ciclo. */
  document.addEventListener('visibilitychange', () => {
    if (document.hidden || $('ce-esperando').hidden) return;
    api('/estado').then(d => { S.datos = d; clearInterval(vigilando); inicio(); }).catch(() => {});
  });

  async function arrancar() {
    try {
      S.datos = await api('/estado');
    } catch (e) {
      /* 401 sin sesión: no es un fallo, es que hay que iniciar sesión.
         Se distingue de un error real porque la salida es distinta. */
      if (e.status === 401) {
        $('ce-nav').hidden = true;
        ver('ce-login');
        /* La muestra se pide solo aquí, y sin bloquear: si falla, la
           pantalla se queda sin la imagen de ejemplo pero el registro
           —que es lo que importa— sigue funcionando. */
        try {
          const m = await api('/muestra');
          if (m.imagen) $('ce-demo').src = m.imagen;
          else $('ce-demo').closest('.stage').hidden = true;
        } catch (_) { $('ce-demo').closest('.stage').hidden = true; }
        return;
      }
      $('ce-load').innerHTML = '<p class="empty">El juego no está disponible ahora mismo.<br>Vuelve a intentarlo en unos minutos.</p>';
      return;
    }
    inicio();
  }
  arrancar();
})();
